//var cur_domain = '';
jQuery(document).ready(function ($) {

    // fancyBox re-measures the popup on every window resize (on mobile that fires whenever the
    // address bar shows/hides or the keyboard opens). While measuring it pulls the content out of
    // the flow for a moment, the overlay's scroll height collapses and the browser resets its
    // scrollTop to 0 — the popup "jumps" to the top. Keep the scroll position across the re-measure.
    if ($.fancybox && $.fancybox._setDimension) {
        var fancyboxSetDimension = $.fancybox._setDimension;
        $.fancybox._setDimension = function () {
            var scrollers = $('.fancybox-overlay, .fancybox-inner').map(function () {
                return { el: this, top: this.scrollTop };
            }).get();
            fancyboxSetDimension.apply(this, arguments);
            $.each(scrollers, function (i, s) {
                s.el.scrollTop = s.top;
            });
        };
    }

    // Domains table on mobile: the row actions sit behind one toggle (see .domain-actions in app.less).
    // The menu is position: fixed, placed here next to the toggle, since the table wrapper scrolls
    // horizontally and would clip it. Any scroll / resize / outside click closes it.
    function closeDomainActions() {
        $('#domains_table .domain-actions.open')
            .removeClass('open')
            .find('.domain-actions-toggle').attr('aria-expanded', 'false');
    }

    $(document).on('click', '.domain-actions-toggle', function (e) {
        e.preventDefault();

        var cell = $(this).closest('.domain-actions');
        var wasOpen = cell.hasClass('open');

        closeDomainActions();

        if (wasOpen) {
            return;
        }

        cell.addClass('open');
        $(this).attr('aria-expanded', 'true');

        var menu = cell.find('.domain-actions-menu');
        var rect = this.getBoundingClientRect();
        var top = rect.bottom + 4;
        var left = rect.right - menu.outerWidth();

        // Open upwards when there is no room below; keep it inside the viewport sideways.
        if (top + menu.outerHeight() > window.innerHeight) {
            top = Math.max(4, rect.top - menu.outerHeight() - 4);
        }
        left = Math.max(4, Math.min(left, window.innerWidth - menu.outerWidth() - 4));

        menu.css({ top: top, left: left });
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.domain-actions-toggle').length) {
            closeDomainActions();
        }
    });

    $(window).on('resize', closeDomainActions);
    // scroll does not bubble: listen on the page and on the table's horizontal scroller.
    window.addEventListener('scroll', closeDomainActions, true);

    $(window).scroll(function(){
        if ($(window).scrollTop() >= 100) {
             $('#Header').addClass('fixed-header');
            // $('#topHeader,#bottomHeader').addClass('fixed-header');
            // $('#bottomHeader').addClass('fixed-header1');
            // $('#Header').css('height',119);
            $('#h-helper').css('height',119);
        }
        else {
            $('#Header').removeClass('fixed-header');
            // $('#bottomHeader').removeClass('fixed-header1');
            // $('#Header').css('height','unset');
            $('#h-helper').css('height',0);
        }
    });

    $(".boxNavButton").click(function () {
        $(window).width() < 768
            ? $(this).hasClass("activeSideBar")
                ? $(this).removeClass("activeSideBar").closest("header").find("#mobileSideBar").css({ right: "100%", left: "-100%" })
                : $(this).addClass("activeSideBar").closest("header").find("#mobileSideBar").css({  left: "0px",right : "0" })
            : $(this).hasClass("activeSideBar")
            ? $(this).removeClass("activeSideBar").closest("header").find("#mobileSideBar").css({ right: "100%", left: "-100%" })
            : $(this)
                  .addClass("activeSideBar")
                  .closest("header")
                  .find("#mobileSideBar")
                  .css({ left: ($(window).width() - 768) / 2, right: ($(window).width() - 768) / 2 });
    })
    var pos = '';
    var tr;
    $(document).on('click', '#addDnsRow button', function(e){
        e.preventDefault();
        pos = '';
        $('#' + $(this).attr('data-target')).modal('show').find('.alert').addClass('hidden');
    });

    $(document).on('click','a.editZoneEntry',function(e){
        e.preventDefault();
        pos = '';
        tr = $(this).closest('tr');

        var updateCsrfToken = function (form, response) {
            form.find('[name=csrf_token]').val(response['csrf_token']);
            form.find('[name=csrf_token_name]').val(response['csrf_token_name']);
        };

        tr.find('select').each(function(){
            var name_attr = $(this).attr('name');
            if (name_attr.indexOf('type')>0)
            {
                var sel = $(this).val();
                var uid = $(this).closest('form').attr('data-uid');
                var url = Storage.getData('app_url') + 'domain/manageEditDomain/' + uid;
                var res = name_attr.match(/[0-9]+/gi);
                var zone = res[0];
                var ttlSelect = $('.modal-dns-edit-record').find('select');
                pos = parseInt(zone);

                var target = tr.find('input[name$="[record]"]').val();
                var domain = tr.find('input[name$="[name]"]').val();
                var ttl = tr.find('select[name^="zone["][name$="[ttl]"]').val();
                var sub = domain.replace(cur_d, '').replace(/\.+$/, "");

                var priority = tr.find('input[name^="priority["]').val();

                if(typeof undefined !== typeof ttl && ttlSelect.length > 0) {
                    ttlSelect.val(ttl);
                }

                if(sel === "HTTPRED"){
                    var redType = tr.find('input[name$="[status]"]').val();

                    $('#editDnsRowREDModal').modal('show').find('.alert').addClass('hidden');
                    $('#editDnsRowREDModal').find('input[name=recordRED]').val(target);

                    if(redType == '301')
                    {
                        $('#typered3').prop( "checked", true );
                        $('#typered4').prop( "checked", false );

                        $('#editDnsRowREDModal').find('input[id=typered3]').prop( "checked", true );
                        $('#editDnsRowREDModal').find('input[id=typered4]').prop( "checked", false );
                    }
                    else
                    {
                        $('#typered3').prop( "checked", false );
                        $('#typered4').prop( "checked", true );

                        $('#editDnsRowREDModal').find('input[id=typered3]').prop( "checked", false );
                        $('#editDnsRowREDModal').find('input[id=typered4]').prop( "checked", true );
                    }
                    return;
                }

                if(sel === "CNAME")
                {
                    $('#editDnsRowCNAMEModal').modal('show').find('.alert').addClass('hidden');
                    $('#editDnsRowCNAMEModal').find('input[name=hostnameCNAME]').val(sub);
                    $('#editDnsRowCNAMEModal').find('input[name=recordCNAME]').val(target);

                    $('#editDnsRowCNAMEModal').find('.select2').val(ttl);

                    return;
                }

                if(sel === "TXT")
                {
                    $('#editDnsRowTXTModal').modal('show').find('.alert').addClass('hidden');
                    $('#editDnsRowTXTModal').find('input[name=hostnameTXT]').val(sub);
                    $('#editDnsRowTXTModal').find('input[name=recordTXT]').val(target);

                    $('#editDnsRowTXTModal').find('.select2').val(ttl);

                    return;
                }

                if(sel === "A")
                {
                    $('#editDnsRowAModal').modal('show').find('.alert').addClass('hidden');
                    $('#editDnsRowAModal').find('input[name=hostnameA]').val(sub);
                    $('#editDnsRowAModal').find('input[name=recordA]').val(target);

                    $('#editDnsRowAModal').find('.select2').val(ttl);

                    return;
                }

                if(sel === "AAAA")
                {
                    $('#editDnsRowAAAAModal').modal('show').find('.alert').addClass('hidden');
                    $('#editDnsRowAAAAModal').find('input[name=hostnameAAAA]').val(sub);
                    $('#editDnsRowAAAAModal').find('input[name=recordAAAA]').val(target);

                    $('#editDnsRowAAAAModal').find('.select2').val(ttl);

                    return;
                }

                if(sel === "MX")
                {
                    $('#editDnsRowMXModal').modal('show').find('.alert').addClass('hidden');
                    $('#editDnsRowMXModal').find('input[name=hostMX]').val(sub);
                    $('#editDnsRowMXModal').find('input[name=hostnameMX]').val(target);
                    $('#editDnsRowMXModal').find('input[name=recordMX]').val(priority);

                    $('#editDnsRowMXModal').find('.select2').val(ttl);

                    return;
                }

                if(sel === "SRV")
                {
                    $('#editDnsRowSRVModal').modal('show').find('.alert').addClass('hidden');

                    var spl = domain.split('.');

                    $('#editDnsRowSRVModal').find('input[name=serviceSRV]').val(spl[0]);
                    $('#editDnsRowSRVModal').find('input[name=hostnameSRV]').val(spl[1]);
                    $('#editDnsRowSRVModal').find('input[name=recordSRV]').val(priority);

                    var prt = target.split(' ');
                    $('#editDnsRowSRVModal').find('input[name=weightSRV]').val(prt[0]);
                    $('#editDnsRowSRVModal').find('input[name=portSRV]').val(prt[1]);
                    $('#editDnsRowSRVModal').find('input[name=targetSRV]').val(prt[2]);

                    $('#editDnsRowSRVModal').find('.select2').val(ttl)

                    return;
                }
            }

        });

        //$('#editDnsRowAModal').modal('show').find('.alert').addClass('hidden');
    });

    // todo@alexbuturlakin: this hardcode need to be refactored
    //create new / edit
    $(document).on('click', '.modalDns .btn-primary', function(e){

        e.preventDefault();
        var window = $(this).closest('div.modalDns');
        var type   = $('.modalDns.in').attr('data-type');
        var ttl    = $('.modalDns.in [name=ttl]').val();

        var
          csrfConfig    = Storage.getData('csrf_config'),
          tokenKey      = csrfConfig['token_key'],
          tokenNameKey  = csrfConfig['token_name_key'],
          csrfToken     = $('.modalDns.in').find('[name=csrf_token]').val(),
          csrfTokenName = $('.modalDns.in').find('[name=csrf_token_name]').val()
        ;

        var addCSRFToDNSData = function (updatednsdata) {
            if (null === updatednsdata) {
                return updatednsdata;
            }

            if ('object' === typeof updatednsdata) {
                updatednsdata[tokenKey] = csrfToken;
                updatednsdata[tokenNameKey] = csrfTokenName;

                return updatednsdata;
            }

            updatednsdata += '&'+tokenKey+'='+csrfToken+'&'+tokenNameKey+'='+csrfTokenName;

            return updatednsdata;
        };

        var clearDNSModal = function () {
          $('.modalDns.in input:not([type=hidden])').val('');
        };

        k++;
        switch(type){
            case 'A':
                var ct = true;
                var errors = '';
                $('.modalDns.in input.form-control').each(function () {
                    if($(this).attr('name') != 'hostnameA') {
                        if (!ctype_print($(this).val())) {
                            ct = false;
                        }
                        if ($(this).val() == '') {
                            ct = false;
                        }
                    }
                });
                if (!ct) {
                    errors += $.translate('English Only') + '\n';
                }

                if(!isValidIPv4( $('.modalDns.in [name=recordA]').val() )){
                     errors += $.translate('Not Valid IPV4') + '\n';
                }
                if(!isValidSubdomain( $('.modalDns.in [name=hostnameA]').val() )){
                     errors += $.translate('Not Valid HostName') + '\n';
                }

                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                }else{
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostnameA]').val();
                    var dom = sub + '.' + cur_d + '.';
                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }

                    var updatednsdata = '';
                    if(pos === '') {
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
							<tr class="row-a">\
								<td>\
									<input readonly disabled type="text" value="'+dom+'" name="zone[' + k + '][name]">\
								</td>\
								<td>\
									<select  readonly disabled name="zone['+k+'][ttl]">\
										<option value="3600">3600</option>\
										<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
									</select>\
								</td>\
								<td>\
									<select readonly disabled name="zone['+k+'][type]">\
										<option value="NS" class="hidden">NS</option>\
										<option value="A" selected="selected">A</option>\
                                        <option value="AAAA">AAAA</option>\
										<option value="MX">MX</option>\
										<option value="SRV">SRV</option>\
										<option value="TXT">TXT</option>\
										<option value="CNAME">CNAME</option>\
										<option value="HTTPRED">HTTPRED</option>\
									</select>\
								</td>\
								<td>\
									<input readonly disabled type="text" value="'+ $('.modalDns.in [name=recordA]').val()  +'" name="zone['+k+'][record]">\
								</td>\
								<td>\
									<a class="delZoneEntry" href="#del" title="מחיקה">\
										<span class="glyphicon glyphicon-trash"></span></a>\
									<a class="editZoneEntry" href="#edit" title="מחיקה">\
										<span class="glyphicon glyphicon-edit"></span></a>\
									</td>\
							<tr>\
						');
                        updatednsdata = 'zone[name]='+dom+'&zone[record]='+ $('.modalDns.in [name=recordA]').val()+'&zone[ttl]=' + ttl + '&zone[type]=A';
                    } else {
                        $("input[name='zone\\["+pos+"\\]\\[record\\]']").val($('.modalDns.in [name=recordA]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(dom);
                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }
                        updatednsdata = 'zone[name]='+dom+'&zone[record]='+ $('.modalDns.in [name=recordA]').val()+'&zone[ttl]=' + ttl + '&zone[type]=A';
                    }
                    clearDNSModal();
                    //ALIN:
                    var id = window.attr('id');

                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0)
                    {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    }
                    else
                    {
                        $('#save-zone').button('reset');
                    }
                    //:ALIN
                    $('.modalDns.in').modal('hide');
                }
                break;
            case 'AAAA':
                var ct = true;
                var errors = '';
                $('.modalDns.in input.form-control').each(function () {
                    if($(this).attr('name') != 'hostnameAAAA') {
                        if (!ctype_print($(this).val())) {
                            ct = false;
                        }
                        if ($(this).val() == '') {
                            ct = false;
                        }
                    }
                });
                if (!ct) {
                    errors += $.translate('English Only') + '\n';
                }

                if(!isValidIPv6( $('.modalDns.in [name=recordAAAA]').val() )){
                     errors += $.translate('Not Valid IPV4') + '\n';
                }
                if(!isValidSubdomain( $('.modalDns.in [name=hostnameAAAA]').val() )){
                     errors += $.translate('Not Valid HostName') + '\n';
                }

                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                }else{
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostnameAAAA]').val();
                    var dom = sub + '.' + cur_d + '.';
                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }

                    var updatednsdata = '';
                    if(pos === '') {
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
							<tr class="row-aaaa">\
								<td>\
									<input readonly disabled type="text" value="'+dom+'" name="zone[' + k + '][name]">\
								</td>\
								<td>\
									<select  readonly disabled name="zone['+k+'][ttl]">\
										<option value="3600">3600</option>\
										<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
									</select>\
								</td>\
								<td>\
									<select readonly disabled name="zone['+k+'][type]">\
										<option value="NS" class="hidden">NS</option>\
										<option value="A">A</option>\
                                        <option value="AAAA" selected="selected">AAAA</option>\
										<option value="MX">MX</option>\
										<option value="SRV">SRV</option>\
										<option value="TXT">TXT</option>\
										<option value="CNAME">CNAME</option>\
										<option value="HTTPRED">HTTPRED</option>\
									</select>\
								</td>\
								<td>\
									<input readonly disabled type="text" value="'+ $('.modalDns.in [name=recordAAAA]').val()  +'" name="zone['+k+'][record]">\
								</td>\
								<td>\
									<a class="delZoneEntry" href="#del" title="מחיקה">\
										<span class="glyphicon glyphicon-trash"></span></a>\
									<a class="editZoneEntry" href="#edit" title="מחיקה">\
										<span class="glyphicon glyphicon-edit"></span></a>\
									</td>\
							<tr>\
						');
                        updatednsdata = 'zone[name]='+dom+'&zone[record]='+ $('.modalDns.in [name=recordAAAA]').val()+'&zone[ttl]=' + ttl + '&zone[type]=AAAA';
                    } else {
                        $("input[name='zone\\["+pos+"\\]\\[record\\]']").val($('.modalDns.in [name=recordAAAA]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(dom);
                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }
                        updatednsdata = 'zone[name]='+dom+'&zone[record]='+ $('.modalDns.in [name=recordAAAA]').val()+'&zone[ttl]=' + ttl + '&zone[type]=AAAA';
                    }
                    clearDNSModal();
                    //ALIN:
                    var id = window.attr('id');

                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0)
                    {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    }
                    else
                    {
                        $('#save-zone').button('reset');
                    }
                    //:ALIN
                    $('.modalDns.in').modal('hide');
                }
                break;
            case 'CNAME':
                var ct = true;
                var errors = '';
                $('.modalDns.in input.form-control').each(function () {
                    if($(this).attr('name') != 'hostnameCNAME') {

                        if (!ctype_print($(this).val())) {
                            ct = false;
                        }
                        if ($(this).val() == '') {
                            ct = false;
                        }
                    }
                });
                if (!ct) {
                    errors += $.translate('English Only') + '\n';
                }
                if($('.modalDns.in [name=hostnameCNAME]').val().length === 0){
                    errors += $.translate('Cannot config CNAME for primary host') + '\n';
                }

                if (!isValidSubdomain($('.modalDns.in [name=hostnameCNAME]').val(), true)) {
                    errors += $.translate('Not Valid HostName') + '\n';
                }
                if (!isValidFullDomain($('.modalDns.in [name=recordCNAME]').val(), true)) {
                    errors += $.translate('Not Valid HostName Target') + '\n';
                }
                
                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                }else{
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostnameCNAME]').val();
                    var dom = sub + '.' + cur_d + '.';
                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }
                    var updatednsdata = '';
                    if(pos === ''){
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
						<tr class="row-cname">\
							<td>\
								<input readonly disabled type="text" value="' + dom + '" name="zone[' + k + '][name]">\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][ttl]">\
									<option value="3600">3600</option>\
									<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
								</select>\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][type]">\
									<option value="NS" class="hidden">NS</option>\
									<option value="A">A</option>\
                                    <option value="AAAA">AAAA</option>\
									<option value="MX">MX</option>\
									<option value="SRV">SRV</option>\
									<option value="TXT">TXT</option>\
									<option value="CNAME" selected="selected">CNAME</option>\
									<option value="HTTPRED">HTTPRED</option>\
								</select>\
							</td>\
							<td>\
								<input readonly disabled type="text" value="'+ $('.modalDns.in [name=recordCNAME]').val()  +'" name="zone['+k+'][record]">\
							</td>\
							<td>\
								<a class="delZoneEntry" href="#del" title="מחיקה">\
									<span class="glyphicon glyphicon-trash"></span></a>\
								<a class="editZoneEntry" href="#edit" title="מחיקה">\
									<span class="glyphicon glyphicon-edit"></span></a>\
								</td>\
						<tr>\
					');

                    } else {
                        $("input[name='zone\\["+pos+"\\]\\[record\\]']").val($('.modalDns.in [name=recordCNAME]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(dom);
                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }
                    }
                    updatednsdata = 'zone[name]='+dom+'&zone[record]='+ $('.modalDns.in [name=recordCNAME]').val()+'&zone[ttl]=' + ttl + '&zone[type]=CNAME';
                    var id = window.attr('id');

                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0)
                    {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    }
                    else {
                        $('#save-zone').button('reset');
                    }
                    //:ALIN
                    clearDNSModal();

                    $('.modalDns.in').modal('hide');
                }
                break;
            case 'TXT':
                var ct = true;
                var errors = '';
                //	if(pos === ''){
                $('.modalDns.in input.form-control').each(function () {
                    if($(this).attr('name') != 'hostnameTXT') {
                        if (!ctype_print($(this).val())) {
                            ct = false;
                        }
                        if ($(this).val() == '') {
                            ct = false;
                        }
                    }
                });
                if (!ct) {
                    errors += $.translate('English Only') + '\n';
                }
                if (!isValidSubdomain($('.modalDns.in [name=hostnameTXT]').val(), true)) {
                     errors += $.translate('Not Valid HostName') + '\n';
                }
                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                } else {
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostnameTXT]').val();
                    var dom = sub + '.' + cur_d + '.';

                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }

                    var updatednsdata = '';

                    if(pos === ''){
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
						<tr class="row-txt">\
							<td>\
								<input readonly disabled type="text" value="' + dom + '" name="zone[' + k + '][name]">\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][ttl]">\
									<option value="3600">3600</option>\
									<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
								</select>\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][type]">\
									<option value="NS" class="hidden">NS</option>\
									<option value="A">A</option>\
                                    <option value="AAAA">AAAA</option>\
									<option value="MX">MX</option>\
									<option value="SRV">SRV</option>\
									<option value="TXT" selected="selected">TXT</option>\
									<option value="CNAME">CNAME</option>\
									<option value="HTTPRED">HTTPRED</option>\
								</select>\
							</td>\
							<td>\
								<input readonly disabled type="text" value="'+ $('.modalDns.in [name=recordTXT]').val()  +'" name="zone['+k+'][record]">\
							</td>\
							<td>\
								<a class="delZoneEntry" href="#del" title="מחיקה">\
									<span class="glyphicon glyphicon-trash"></span></a>\
								<a class="editZoneEntry" href="#edit" title="מחיקה">\
									<span class="glyphicon glyphicon-edit"></span></a>\
								</td>\
						<tr>\
					');
                    } else {
                        $("input[name='zone\\["+pos+"\\]\\[record\\]']").val($('.modalDns.in [name=recordTXT]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(dom);
                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }
                    }

                    updatednsdata = {
                        zone: {
                            name_entered: sub,
                            name: dom,
                            record: $('.modalDns.in [name=recordTXT]').val(),
                            ttl: ttl,
                            type: 'TXT'
                        }
                    };

                    var id = window.attr('id');
                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0)
                    {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    }
                    else
                    {
                        $('#save-zone').button('reset');
                    }
                    //:ALIN
                    clearDNSModal();
                    $('.modalDns.in').modal('hide');
                }
                break;
            case 'MX':
                var ct = true;
                var errors = '';
                $('.modalDns.in input.form-control').each(function () {
                    if($(this).attr('name') != 'hostMX') {
                        if (!ctype_print($(this).val())) {
                            ct = false;
                        };
                        if($(this).val() == ''){
                            ct = false;
                        }
                    }
                });
                if (!ct) {
                    errors += $.translate('English Only') + '\n';
                }
                if (!isValidFullDomain($('.modalDns.in [name=hostnameMX]').val())) {
                    errors += $.translate('Not Valid HostName Target') + '\n';
                }

                var priority = $('.modalDns.in [name=recordMX]').val();
                if(isNaN(priority) || parseInt(priority) < 0 || parseInt(priority) > 65535){
                    errors += $.translate('Priority must be between 0 and 65535') + '\n';
                }

                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                }else{
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostMX]').val();
                    var dom = sub + '.' + cur_d + '.';
                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }
                    if(pos === ''){
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
						<tr class="row-mx">\
							<td>\
							    <input type="hidden" name="priority[' + k + ']" value="'+$('.modalDns.in [name=recordMX]').val()+'">\
								<input readonly disabled type="text" value="'+dom+'." name="zone[' + k + '][name]">\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][ttl]">\
									<option value="3600">3600</option>\
									<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
								</select>\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][type]">\
									<option value="NS" class="hidden">NS</option>\
									<option value="A">A</option>\
                                    <option value="AAAA">AAAA</option>\
									<option value="MX" selected="selected">MX</option>\
									<option value="SRV">SRV</option>\
									<option value="TXT">TXT</option>\
									<option value="CNAME">CNAME</option>\
									<option value="HTTPRED">HTTPRED</option>\
								</select>\
							</td>\
							<td>\
								<input readonly disabled type="text" value="' + $('.modalDns.in [name=hostnameMX]').val() + '." name="zone['+k+'][record]">\
							</td>\
							<td>\
								<a class="delZoneEntry" href="#del" title="מחיקה">\
									<span class="glyphicon glyphicon-trash"></span></a>\
								<a class="editZoneEntry" href="#edit" title="מחיקה">\
									<span class="glyphicon glyphicon-edit"></span></a>\
								</td>\
						<tr>\
					');
                    } else {
                        $("input[name='zone\\["+pos+"\\]\\[record\\]']").val($('.modalDns.in [name=hostnameMX]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(dom);
                        $("input[name='priority\\["+pos+"\\]']").val($('.modalDns.in [name=recordMX]').val());
                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }
                    }
                    var updatednsdata = 'zone[name]=' + dom + '&zone[priority]='+ $('.modalDns.in [name=recordMX]').val() + '&zone[record]=' + $('.modalDns.in [name=hostnameMX]').val() +'&zone[ttl]=' + ttl + '&zone[type]=MX';
                    var id = window.attr('id');

                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0) {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    } else {
                        $('#save-zone').button('reset');
                    }
                    //:ALIN
                    clearDNSModal();
                    $('.modalDns.in').modal('hide');
                }
                break;
            case 'SRV':
                var ct = true;
                var errors = '';
                $('.modalDns.in input.form-control').each(function () {
                    if (!ctype_print($(this).val())) {
                        ct = false;
                    };
                    if($(this).val() == ''){
                        ct = false;
                    }
                });
                if (!ct) {
                    errors += $.translate('English Only') + '\n';
                }
                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                }else{
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostnameSRV]').val();
                    var dom = sub + '.' + cur_d + '.';
                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }
                    if(pos === ''){ // +St: name["serviceSRV"] ==> hostnameSRV
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
						<tr class="row-srv">\
							<td>\
							    \<input type="hidden" name="priority[' + k + ']" value="'+$('.modalDns.in [name=recordSRV]').val()+'">\
								<input readonly disabled type="text" value="' + $('.modalDns.in [name="serviceSRV"]').val() + '.'  + $('.modalDns.in [name="hostnameSRV"]').val() + '.' + cur_d + '" name="zone[' + k + '][name]">\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][ttl]">\
									<option value="3600">3600</option>\
									<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
								</select>\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][type]">\
									<option value="NS" class="hidden">NS</option>\
									<option value="A">A</option>\
                                    <option value="AAAA">AAAA</option>\
									<option value="MX">MX</option>\
									<option value="SRV" selected="selected">SRV</option>\
									<option value="TXT">TXT</option>\
									<option value="CNAME">CNAME</option>\
									<option value="HTTPRED">HTTPRED</option>\
								</select>\
							</td>\
							<td>\
								<input readonly disabled type="text" value="' /*+ $('.modalDns.in [name=recordSRV]').val()  + ' '*/ + $('.modalDns.in [name=weightSRV]').val() + ' ' + $('.modalDns.in [name=portSRV]').val() + ' ' + $('.modalDns.in [name=targetSRV]').val() + '" name="zone['+k+'][record]">\
							</td>\
							<td>\
								<a class="delZoneEntry" href="#del" title="מחיקה">\
									<span class="glyphicon glyphicon-trash"></span></a>\
								<a class="editZoneEntry" href="#edit" title="מחיקה">\
									<span class="glyphicon glyphicon-edit"></span></a>\
								</td>\
						<tr>\
					');
                    } else {
                        /*$("input[name='zone\\["+pos+"\\]\\[record\\]']").val(
						$('.modalDns.in [name=recordSRV]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(cur_d);*/

						$("input[name='zone\\["+pos+"\\]\\[record\\]']").val(
						$('.modalDns.in [name=weightSRV]').val() + ' '
						+ $('.modalDns.in [name=portSRV]').val() + ' '
						+ $('.modalDns.in [name=targetSRV]').val());

                        $("input[name='priority\\["+pos+"\\]']").val($('.modalDns.in [name=recordSRV]').val());

                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }

                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val($('.modalDns.in [name=serviceSRV]').val() + '.' + $('.modalDns.in [name=hostnameSRV]').val() + '.' + cur_d);

                    }
					/*
                    var updatednsdata = 'zone[name]='+cur_d+'&zone[record]='+ $('.modalDns.in [name=recordSRV]').val()+'&zone[ttl]=14400&zone[type]=SRV';
                    */
					// +St:
					var hostCode  =
					  $('.modalDns.in [name=serviceSRV]').val() + '.'
					+ $('.modalDns.in [name=hostnameSRV]').val() + '.'
					/*+ $('.modalDns.in [name=recordSRV]').val() + '.'*/ + cur_d;
					var ValueCode =
					  $('.modalDns.in [name=weightSRV]').val() + ' '
					+ $('.modalDns.in [name=portSRV]').val() + ' '
					+ $('.modalDns.in [name=targetSRV]').val();

					var updatednsdata =
					'zone[name]='+ hostCode + '&zone[record]='+ ValueCode+'&zone[ttl]=' + ttl + '&zone[type]=SRV&zone[priority]='+$('.modalDns.in [name=recordSRV]').val();
					var id = window.attr('id');

                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0) {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){

                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    } else {
                        $('#save-zone').button('reset');
                    }
                    //:ALIN

                    clearDNSModal();
                    $('.modalDns.in').modal('hide');
                }
                break;
            case 'RED':
                var ct = true;
                var errors = '';
                $('.modalDns.in input.form-control').each(function () {
                    if (!ctype_print($(this).val())) {
                        ct = false;
                    };
                    if($(this).val() == ''){
                        ct = false;
                    }
                });
                if (!ct) {
                     errors += $.translate('English Only') + '\n';
                }
                if(!isValidURL( $('.modalDns.in [name=recordRED]').val() )){
                     errors += $.translate('Not Valid URL') + '\n';
                }

                if((errors !== '')){
                    $('.modalDns.in .alert').html(nl2br(errors)).removeClass('hidden');
                    return;
                }else{
                    $('.modalDns.in .alert').addClass('hidden');
                    var sub = $('.modalDns.in [name=hostnameSRV]').val();
                    var dom = sub + '.' + cur_d + '.';
                    if(sub == '' || ('string' === typeof sub  && '@' == sub.trim())){
                        dom = cur_d + '.';
                    }

                    var redtype = 301;
                    if($('#typered3').is(':checked')) { redtype=302;}

                    if(pos === ''){
                        $('#updatezone .table tbody tr.row-red').remove();
                        $('#updatezone .table tbody tr').eq($('#updatezone .table tbody tr').length - 1).before('\
						<tr class="row-red">\
							<td>\
								<input  type="hidden" value="' + redtype + '" name="zone[' + k + '][status]">\
								<input readonly disabled type="text" value="' + cur_d + '" name="zone[' + k + '][name]">\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][ttl]">\
									<option value="3600">3600</option>\
									<option value="' + ttl + '" selected="selected">' + ttl + '</option>\
								</select>\
							</td>\
							<td>\
								<select readonly disabled name="zone['+k+'][type]">\
									<option value="NS" class="hidden">NS</option>\
									<option value="A">A</option>\
                                    <option value="AAAA">AAAA</option>\
									<option value="MX">MX</option>\
									<option value="SRV">SRV</option>\
									<option value="TXT">TXT</option>\
									<option value="CNAME">CNAME</option>\
									<option value="HTTPRED"  selected="selected">HTTPRED</option>\
								</select>\
							</td>\
							<td>\
								<input readonly disabled type="text" value="'+ $('.modalDns.in [name=recordRED]').val()  +'" name="zone['+k+'][record]">\
							</td>\
							<td>\
								<a class="delZoneEntry" href="#del" title="מחיקה">\
									<span class="glyphicon glyphicon-trash"></span></a>\
								<a class="editZoneEntry" href="#edit" title="מחיקה">\
									<span class="glyphicon glyphicon-edit"></span></a>\
								</td>\
						<tr>\
					');
                    } else {
                        $("input[name='zone\\["+pos+"\\]\\[record\\]']").val($('.modalDns.in [name=recordRED]').val());
                        $("input[name='zone\\["+pos+"\\]\\[name\\]']").val(cur_d);
                        $("input[name='zone\\["+pos+"\\]\\[status\\]']").val(redtype);
                        if(typeof undefined !== typeof ttl) {
                            $("select[name='zone\\["+pos+"\\]\\[ttl\\]']").val(ttl);
                        }
                    }


                    var zone = {
                        name: cur_d,
                        redtype: redtype,
                        record: $('.modalDns.in [name=recordRED]').val(),
                        ttl: ttl,
                        type: 'HTTPRED'
                    };

                    var updatednsdata = {
                        zone: zone
                    };

                    var id = window.attr('id');

                    updatednsdata = addCSRFToDNSData(updatednsdata);

                    if (id.indexOf('addDns') >=0)
                    {
                        $.post(Storage.getData('app_url') + 'domain/new-record/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                            /*	r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    }
                    else
                    {
                        $.post(Storage.getData('app_url') + 'domain/update-record/' + cur_d, $.extend({}, updatednsdata, { uid: $('#updatezone').attr('data-uid') }), function(r){
                            /*r = JSON.parse(r);
                             if(r.status == 0){
                             $('#zone-error').html(r.msg).removeClass('hidden');
                             }
                             if(r.status == 1){
                             $.fancybox.close();
                             $('#domainflash').html(r.msg).removeClass('hidden');
                             }*/
                            $('#save-zone').button('reset');
                        });
                    }
                    //:ALIN

                    clearDNSModal();
                    $('.modalDns.in').modal('hide');
                }
                break;
        }
    })
    $(document).on('click', '.delZoneEntry', function(e){
      e.preventDefault();

      var
          del           = $(this),
          recordID      = $(this).closest('tr').find('input[name=recordID]').val(),
          form          = del.closest('#updatezone'),
          csrfConfig    = Storage.getData('csrf_config'),
          tokenKey      = csrfConfig['token_key'],
          tokenNameKey  = csrfConfig['token_name_key'],
          csrfToken     = form.find('[name=csrf_token]').val(),
          csrfTokenName = form.find('[name=csrf_token_name]').val(),
          updatednsdata = "type="+$(this).closest('tr').find(".zoneType").val()
      ;

        updatednsdata += '&'+tokenKey+'='+csrfToken+'&'+tokenNameKey+'='+csrfTokenName;

        if ($(this).closest('tr').find(".zoneType").val() === 'HTTPRED'){
            recordID = $(this).closest('tr').find(".zoneName").val();

            $.post(Storage.getData('app_url') + 'domain/delete-record/' + recordID, updatednsdata + '&uid=' + $('#updatezone').attr('data-uid'), function(r){
                /*	r = JSON.parse(r);
                 if(r.status == 0){
                 $('#zone-error').html(r.msg).removeClass('hidden');
                 }
                 if(r.status == 1){
                 $.fancybox.close();
                 $('#domainflash').html(r.msg).removeClass('hidden');
                 }*/

            });
        }


        del.parent().parent().remove();

    });
    $(document).on('click', '#save-zone', function(e){
        e.preventDefault();

        var recordsCount = $("#updatezone").find('table tbody tr').length;
        if(recordsCount > 100){
            var error =  $.translate('Maximum 100 records allowed!');
            $('#zone-error').html(error).removeClass('hidden');
            return false;
        }

        $('#zone-error').addClass('hidden');
        $('#save-zone').button('loading');
        var errors = '';
        var ct = true;
        $('#updatezone input').each(function () {
            if (!ctype_print_heb($(this).val())) {
                ct = false;
            };
        });
        if (!ct) {
            errors += $.translate('English Only') + '\n';
        }
        if(errors !== ''){
            $('#zone-error').html(nl2br(errors, true)).removeClass('hidden');
            $('#save-zone').button('reset');
        } else {
            $("#updatezone").find(':input:disabled').prop('disabled', false);
            var updatednsdata = $('#updatezone').serialize();
            $("#updatezone").find(':input').prop('disabled', true);

            $.post(Storage.getData('app_url') + 'domain/update-dns/' + $('#updatezone').attr('data-uid'), updatednsdata, function(r){
                r = JSON.parse(r);
                if(r.status == 0){
                    $('#zone-error').html(r.msg).removeClass('hidden');
                }
                if(r.status == 1){
                    $.fancybox.close();
                    $('#domainflash').html(r.msg).removeClass('hidden');
                }
                $('#save-zone').button('reset');
            })
        }
    })
    $(document).on('click', '#dnsChoser a', function (e) {
        e.preventDefault();
        if (!$(this).parent().hasClass('disabled')) {
            $(this).tab('show');
        }
    });

    var isZoneEditorLocked = function () {
        var $overlay = $('#zone-editor-disclaimer');
        return $overlay.length && $overlay.is(':visible');
    };

    $(document).on('change', '#zone-editor-agree-check', function () {
        $('#zone-editor-agree-btn').prop('disabled', !this.checked);
    });

    $(document).on('click', '#zone-editor-agree-btn', function (e) {
        e.preventDefault();
        if (!$('#zone-editor-agree-check').is(':checked')) {
            return false;
        }
        $('.zone-editor-lock-wrap').addClass('is-unlocked');
        $('#zone-editor-disclaimer').hide();
    });

    $(document).on('click', '#addDnsRow button, a.editZoneEntry, a.delZoneEntry, #save-zone', function (e) {
        if (isZoneEditorLocked()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
    });

    // $(document).on('click', '#action-show-terms', function (e) {
    //     $.fancybox({
    //         href: $(this).attr('href'),
    //         type: 'iframe'
    //     });

    //     e.preventDefault();
    // });

    $(document).on('click', '#renew-domain #checkCoupon', function (e) {
        var form = $(this).closest('form');
        var cpn = $('#couponCode').val();
        $('#cpn-error').addClass('hidden');
        //$('#cpnDis').addClass('hidden');
        $(this).button('loading');
        form.find('#creditDetails input[type=text]').parent().show();
        form.find('#creditDetails select').parent().show();
        form.find('#creditNumber').val('');
        form.find('#creditExpirationYear option').eq(0).prop('selected', true);
        form.find('#creditExpirationMonth option').eq(0).prop('selected', true);
        form.find('#creditCvv').val('');
        form.find('#creditId').val('');
        $.get(Storage.getData('app_url') + 'checkCpn/' + cpn, '', function (r) {
            r = parseFloat(r);
            if (r <= 0) {
                $('#cpn-error').removeClass('hidden');
                $('#cpnDis').addClass('hidden');
            } else {
                $('#cpn-error').addClass('hidden');
                var price = $('#renew-domain .UIInfoBox > span > span').html();
                var dis = price - r;
                if (dis <= 0) {
                    dis = 0;
                    form.find('#creditDetails input[type=text]').parent().hide();
                    form.find('#creditDetails select').parent().hide();
                    form.find('#creditNumber').val('378282246310005');
                    form.find('#creditExpirationYear').val(new Date().getFullYear() + 5);
                    form.find('#creditExpirationMonth').val(12);
                    form.find('#creditCvv').val(123);
                    form.find('#creditId').val(123456789);
                }
                $('.amount').html(price);
                $('.sum').html(Number(dis).toFixed(2))
                $('#cpnDis').removeClass('hidden');
            }
            $('#checkCoupon').button('reset');
        });
        $('#checkCoupon').button('reset');
    })
    $(document).on('click', '#domain_order #checkCoupon', function (e) {
        var cpn = $('#couponCode').val();
        var placeholder = '<div class="col-md-6" id="enomPlaceholder" style="height: 200px;"></div>';
        $('#cpn-error').addClass('hidden');
        //$('#cpnDis').addClass('hidden');
        $(this).button('loading');
        $.get(Storage.getData('app_url') + 'checkCpn/' + cpn, '', function (r) {
            r = parseFloat(r);
            $('#creditNumber').val('');
            $('#creditExpirationYear option').eq(0).prop('selected', true);
            $('#creditExpirationMonth option').eq(0).prop('selected', true);
            $('#creditCvv').val('');
            $('#creditId').val('');
            $('#enomPlaceholder').remove();
            $('#creditDetails input[type=text]').parent().show();
            $('#creditDetails select').parent().show();
            if (r <= 0) {
                $('#cpn-error').removeClass('hidden');
                $('#cpnDis').addClass('hidden');
            } else {
                $('#cpn-error').addClass('hidden');
                var price = $('#creditCardDetails .UISection span span').html();
                var dis = price - r;
                if (dis <= 0) {
                    dis = 0;
                    $('#creditDetails').before(placeholder);
                    $('#creditDetails input[type=text]').parent().hide();
                    $('#creditDetails select').parent().hide();
                    $('#creditNumber').val('378282246310005');
                    $('#creditExpirationYear').val(new Date().getFullYear() + 5);
                    $('#creditExpirationMonth').val(12);
                    $('#creditCvv').val(123);
                    $('#creditId').val(123456789);
                }

                $('#cpnDis .amount').html(price);
                $('#cpnDis .sum').html(Number(dis).toFixed(2))
                $('#cpnDis').removeClass('hidden');
                // $(this).attr("disabled", disable);
            }
            $('#checkCoupon').button('reset');
        });
    });

    $(document).on('click', '.admin-domain-info', function (e) {
        e.preventDefault();

        $.showXHRModal($(this).attr('href'), function () {$('.fancybox-overlay.fancybox-overlay-fixed').css("z-index", 15104);}, {'title': 'Domain info'});

    });

    $(document).on('click', '.transfer-acc', function (e) {
        e.preventDefault();
        var uid = $(this).closest('tr').data('uid');
        $.get(Storage.getData('app_url') + 'domain/transfer-acc/' + uid, function (r) {
            $.fancybox.open({
                type: 'iframe',
                padding: 0,
                content: r,
                afterShow: function () {

                    $('#transfer-acc-domain').click(function (e) {
                        e.preventDefault();
                        $(this).button('loading');
                        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var emailEl = $('#userEmail');
                        var email = emailEl.val();
                        var errors = '';
                        if (!re.test(email) || email === '') {
                            emailEl.parent().addClass('has-error');
                            errors += $.translate('Email is invalid') + '\n';
                        }
                        else {
                            emailEl.parent().removeClass('has-error');
                        }
                        if (errors !== '') {
                            $('#transfer-acc-errors').html(nl2br(errors, true)).removeClass('hidden');
                            $(this).button('reset');
                        } else {
                            $('#transfer-acc-errors').addClass('hidden');
                            $.post($('#transfer-acc').attr('action') + '/' + uid, $('#transfer-acc').serialize(), function (r) {
                                if (r.status == 1) {
                                    $('#domainflash').html(r.msg).removeClass('hidden');
                                    $('#transfer-acc').addClass('hidden');
                                    $('tr[data-uid="' + uid + '"]').remove();
                                    $.fancybox.close();
                                }
                                if (r.status == 0) {
                                    $('#transfer-acc-errors').html(nl2br(r.msg, true)).removeClass('hidden');
                                }
                                $('#transfer-acc-domain').button('reset');
                            })
                        }
                    });

                    $('#transfer-security-code-confirm').click(function (e) {
                        e.preventDefault();
                        $('#transfer-security-code-initial').addClass('hidden');
                        $('#transfer-security-code-contact').removeClass('hidden');
                    });


                    $('#transfer-security-code-contact-yes').click(function (e) {
                        e.preventDefault();
                        $('#line-loader-transfer-security-code').removeClass('hidden');
                        var uid = $(this).attr('domain-id');
                        $('#transfer-security-code-contact').addClass('hidden');

                        var
                            button = $(this),
                            errorContainer = $('#transfer-acc-errors')
                        ;
                        $(this).button('loading');

                        $.get('/domain/contact-transfer-code-xhr/' + uid, function (r) {
                            button.button('reset');

                            if (r.status) {
                              var msgContainer = $('#transfer-security-code-message-container');

                              errorContainer.addClass('hidden');

                              msgContainer.find('span').html(r.msg);

                              button.hide(function () {
                                msgContainer.removeClass('hidden');
                                $('#line-loader-transfer-security-code').addClass('hidden');
                              });
                            } else {
                              errorContainer.html(nl2br(r.msg, true)).removeClass('hidden');
                              $('#line-loader-transfer-security-code').addClass('hidden');
                            }
                        });

                        // TODO: Send AJAX to mark user wants callback
                        // $.post('/domain/mark-callback-request', {domain_id: uid});
                        
                        // Then get transfer code
                        //getTransferCode($(this), uid);
                    });

                    $('#transfer-security-code-generation').click(function (e) {
                        $('#line-loader-transfer-security-code').removeClass('hidden');
                        var
                            button = $(this),
                            uid = button.attr('domain-id'),
                            errorContainer = $('#transfer-acc-errors')
                        ;
                        $('#transfer-security-code-contact').addClass('hidden');
                        e.preventDefault();
                        $(this).button('loading');

                        $.get('/domain/get-transfer-code-xhr/' + uid, function (r) {
                            button.button('reset');

                            if (r.status) {
                              var msgContainer = $('#transfer-security-code-message-container');

                              errorContainer.addClass('hidden');

                              msgContainer.find('span').html(r.msg);

                              button.hide(function () {
                                msgContainer.removeClass('hidden');
                                $('#line-loader-transfer-security-code').addClass('hidden');
                              });
                            } else {
                              errorContainer.html(nl2br(r.msg, true)).removeClass('hidden');
                              $('#line-loader-transfer-security-code').addClass('hidden');
                            }
                        });
                    });


                    // Remove previous handlers to prevent double registration
                    $(document).off('change', '#lockstateToggle');
                    
                    $(document).on('change', '#lockstateToggle', function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        
                        // Check if there is a request in progress
                        var $toggle = $(this);
                        if ($toggle.data('processing')) {
                            return false;
                        }
                        
                        $toggle.data('processing', true);
                        $('#line-loader-lockstate').removeClass('hidden');
                        $('.lockstateSlider').addClass('hidden');
                        $('#DomainLockStatusLabel').addClass('hidden');
                        var isLocked = $toggle.is(':checked');
                        var label = $('#DomainLockStatusLabel');
                        if (isLocked) {
                            label.addClass('locked');
                            label.removeClass('unlocked');
                        } else {
                            label.addClass('unlocked');
                            label.removeClass('locked');
                        }
                
                        var data = {
                            lockstate: isLocked ? 1 : 0
                        };
                        var uid = $toggle.data('uid');
                        var url = Storage.getData('app_url') + 'domain/lockDomain/' + uid;
                        var csrfConfig = Storage.getData('csrf_config');
                        var form = $toggle.closest('form');
                        data[csrfConfig['token_name_key']] = form.find('[name=csrf_token_name]').val();
                        data[csrfConfig['token_key']]      = form.find('[name=csrf_token]').val();
                
                        $.post(url, data, function (r) {
                            r = JSON.parse(r);
                            $toggle.data('processing', false);
                            
                            if (r.status == 0) {
                                $('#lockstate-errors').html(r.msg).removeClass('hidden');
                                $('#line-loader-lockstate').addClass('hidden');
                            }
                            if (r.status == 1) {
                                $('#lockstate-suc').html(r.msg).removeClass('hidden');
                                $('#line-loader-lockstate').addClass('hidden');
                                
                                // update lock button text and title
                                var lockButton = $('tr[data-uid="' + uid + '"] .lock.transfer-acc');
                                if (isLocked) {
                                    lockButton.removeClass('icon-unlock').addClass('icon-lock');
                                    lockButton.attr('title', r.msg);
                                } else {
                                    lockButton.removeClass('icon-lock').addClass('icon-unlock');
                                    lockButton.attr('title', r.msg);
                                }
                            }
                        }).fail(function() {
                            $toggle.data('processing', false);
                            $('#line-loader-lockstate').addClass('hidden');
                        });
                    });
                }
            });
        })
    });
    $('#getthis, .option .add_btn').click(function (e) {
        e.preventDefault();
        var inDomain = $('input[name=check-domain]').val();
        if (!stristr(inDomain, '.')) {
            inDomain += '.co.il';
        }
        if ($(this).hasClass('add_btn')) {
            var domainparts = inDomain.split('.');
            var domain = domainparts[0];
            inDomain = domain + $(this).data('tld');
        }
        // setCookie('domain', inDomain, 1);

        $.get(Storage.getData('app_url') + 'domain/pre-info', {'dname': inDomain}, function (data) {
            if(data.success) {
              window.location.href = data.page;
            }
        });
    });

    $(document).on('click', '#invoices,#contacts,#mDomains,#settings', function (e) {
        if($(this).attr('id') == 'mDomains' && $(this).hasClass('active')){
            return true;
        }
        e.preventDefault();
        $('#invoices,#contacts,#mDomains,#settings').removeClass('active');
        $(this).addClass('active');
        var id = $(this).attr('id');
        var domains = $('#domain-cont');
        var contacts = $('#contacts-cont');
        var invoices = $('#invoices-cont');
		var settings = $('#account-settings-cont');
        if (id == 'mDomains') {
            domains.removeClass('hidden');
            contacts.addClass('hidden');
            invoices.addClass('hidden');
			settings.addClass('hidden');
        }
        if (id == 'contacts') {
            contacts.removeClass('hidden');
            domains.addClass('hidden');
            invoices.addClass('hidden');
			settings.addClass('hidden');
        }
        if (id == 'invoices') {
            invoices.removeClass('hidden');
            domains.addClass('hidden');
            contacts.addClass('hidden');
			settings.addClass('hidden');
        }
		if (id == 'settings') {
			settings.removeClass('hidden');
			domains.addClass('hidden');
            invoices.addClass('hidden');
			contacts.addClass('hidden');
		}

        // Bring the opened tab's content into view. Target the content itself (not the
        // tab bar): on mobile the tabs wrap into several rows, so a fixed offset from
        // #settings lands mid-bar. Short and interruptible so it never fights the user.
        var shown = $('#domain-cont, #contacts-cont, #invoices-cont, #account-settings-cont').not('.hidden').first();
        if (shown.length) {
            var page = $([document.documentElement, document.body]);
            var target = shown.offset().top - $('#Header').outerHeight() - 10;
            if (target > $(window).scrollTop()) {
                page.stop(true).animate({ scrollTop: target }, 300);
                $(window).one('wheel touchstart keydown', function () {
                    page.stop(true);
                });
            }
        }
    });

    $(document).on('click', '#invoicesSubTab, #paymentMethodsSubTab', function (e) {
        e.preventDefault();
        var tabs = $(this).closest('.account-subtabs');
        tabs.find('li').removeClass('active');
        $(this).closest('li').addClass('active');

        if ($(this).attr('id') == 'paymentMethodsSubTab') {
            $('#invoices-subtab-cont').addClass('hidden');
            $('#payment-methods-subtab-cont').removeClass('hidden');
        } else {
            $('#payment-methods-subtab-cont').addClass('hidden');
            $('#invoices-subtab-cont').removeClass('hidden');
        }
    });

    // Checkout: hide new-card fields when a saved payment method is selected.
    // Must live here (after jQuery loads) — inline scripts in domain/info.php run before bundle.js.
    function toggleCheckoutPaymentMethodFields(select) {
        var $select = $(select);
        var usingSaved = !!$select.val();
        var $scope = $select.closest('#creditDetails, #renew-domain, form, .modal-body');
        if (!$scope.length) {
            $scope = $(document);
        }

        var $fields = $scope.find('#new-card-fields');
        if (!$fields.length) {
            $fields = $('#new-card-fields');
        }
        $fields.toggleClass('hidden', usingSaved);

        // Purchase page warning above the card fields ("Credit card number additional").
        $scope.children('.description.alert-warning').toggleClass('hidden', usingSaved);

        // Bulk renew wraps the whole card block differently.
        $scope.find('#renew-domain-bulk-op-payment-section').toggleClass('hidden', usingSaved);

        var alreadyDomainDefault = usingSaved
            && String($select.val()) === String($select.data('domain-default-id'));

        $scope.find('#paymentMethodExistingDefaultGroup')
            .toggleClass('hidden', !usingSaved || alreadyDomainDefault);

        if (usingSaved) {
            $scope.find('#savePaymentMethod').prop('checked', false);
            $scope.find('#setAsDomainDefaultNew').prop('checked', false);
            if (alreadyDomainDefault) {
                $scope.find('#setAsDomainDefaultExisting').prop('checked', false);
            }
        } else {
            $scope.find('#setAsDomainDefaultExisting').prop('checked', false);
        }
    }

    $(document).on('change', '#paymentMethodId', function () {
        toggleCheckoutPaymentMethodFields(this);
    });

    // Default-for-this-domain only applies to a card that is also saved.
    $(document).on('change', '#savePaymentMethod', function () {
        if ($(this).is(':checked')) {
            return;
        }
        var $scope = $(this).closest('#creditDetails, #renew-domain, form, .modal-body');
        if (!$scope.length) {
            $scope = $(document);
        }
        $scope.find('#setAsDomainDefaultNew').prop('checked', false);
    });

    $(document).on('change', '#setAsDomainDefaultNew', function () {
        if (!$(this).is(':checked')) {
            return;
        }
        var $scope = $(this).closest('#creditDetails, #renew-domain, form, .modal-body');
        if (!$scope.length) {
            $scope = $(document);
        }
        $scope.find('#savePaymentMethod').prop('checked', true);
    });

    function paymentMethodCsrfData() {
        var container = $('#payment-method-csrf').length ? '#payment-method-csrf' : '#admin-payment-method-csrf';

        return {
            csrf_token: $(container + ' input[name="csrf_token"]').val(),
            csrf_token_name: $(container + ' input[name="csrf_token_name"]').val()
        };
    }

    function reloadPaymentMethodsList() {
        var target = $('#payment-methods-list-wrap').length
            ? '#payment-methods-list-wrap'
            : '#payment-methods-subtab-cont';

        $.get(Storage.getData('app_url') + 'payment-methods/list', function (r) {
            $(target).html(r);
        });
    }

    $(document).on('click', '#paymentMethodAddToggle', function (e) {
        e.preventDefault();
        $('#payment-method-add-form-wrap').toggleClass('hidden');
    });

    $(document).on('submit', '#paymentMethodAdd', function (e) {
        e.preventDefault();
        var form = $(this);
        var submitBtn = $('#paymentMethodAddSubmit');

        var creditReg = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
        var date = new Date();
        var creditCard = (form.find('#creditNumber').val() || '').replace(/\D/g, '');
        var creditCardYr = form.find('#creditExpirationYear').val();
        var creditCardMo = form.find('#creditExpirationMonth').val();
        var creditCardCvv = form.find('#creditCvv').val();
        var creditCardId = form.find('#creditId').val();
        var errors = [];

        if (isNaN(creditCard) || creditCard.length < 8 || creditCard.length > 17 || (!creditReg.test(creditCard) && creditCard.length > 9) || creditCard[0] === '0') {
            errors.push($.translate('card is invalid'));
        }
        if (isNaN(creditCardYr) || parseInt(creditCardYr) < date.getFullYear()) {
            errors.push($.translate('Expiry Year is invalid'));
        } else if (parseInt(creditCardYr) === date.getFullYear() && parseInt(creditCardMo) < (date.getMonth() + 1)) {
            errors.push($.translate('Expiry Month is invalid'));
        }
        if (isNaN(creditCardCvv) || creditCardCvv.length < 3 || creditCardCvv.length > 4) {
            errors.push($.translate('cvv is invalid'));
        }
        if (isNaN(creditCardId) || creditCardId.length !== 9) {
            errors.push($.translate('id is invalid'));
        }

        if (errors.length) {
            $('#payment-method-error').html(errors.join('<br>')).removeClass('hidden');
            $('#payment-method-success').addClass('hidden');

            return;
        }

        $('#payment-method-error').addClass('hidden');
        submitBtn.prop('disabled', true);

        // CVV / ID are encrypted server-side and required for later Verify charges on the live terminal.
        $.post(form.attr('action'), form.find(':input').serialize(), function (r) {
            var data = JSON.parse(r);
            submitBtn.prop('disabled', false);

            if (data.status == 1) {
                reloadPaymentMethodsList();
            } else {
                $('#payment-method-error').text(data.msg).removeClass('hidden');
                $('#payment-method-success').addClass('hidden');
            }
        }).fail(function () {
            submitBtn.prop('disabled', false);
        });
    });

    $(document).on('click', '.payment-method-rename', function (e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        var labelCell = row.find('.payment-method-label');
        var currentLabel = labelCell.data('label') !== undefined ? labelCell.data('label') : labelCell.text();

        labelCell.data('label', currentLabel);
        // Build the input via .val(), never by string concatenation: the label is customer-controlled
        // and is also rendered to admins under LOG AS.
        labelCell.empty().append(
            $('<input type="text" class="form-control payment-method-label-input">').val(currentLabel)
        );

        row.find('.payment-method-rename, .payment-method-remove').addClass('hidden');
        row.find('.payment-method-rename-save, .payment-method-rename-cancel').removeClass('hidden');
        row.find('.payment-method-label-input').focus().select();
    });

    $(document).on('keydown', '.payment-method-label-input', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $(this).closest('tr').find('.payment-method-rename-save').click();
        } else if (e.which === 27) {
            e.preventDefault();
            $(this).closest('tr').find('.payment-method-rename-cancel').click();
        }
    });

    $(document).on('click', '.payment-method-rename-cancel', function (e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        var labelCell = row.find('.payment-method-label');

        labelCell.text(labelCell.data('label'));

        row.find('.payment-method-rename, .payment-method-remove').removeClass('hidden');
        row.find('.payment-method-rename-save, .payment-method-rename-cancel').addClass('hidden');
    });

    $(document).on('click', '.payment-method-rename-save', function (e) {
        e.preventDefault();
        var row = $(this).closest('tr');
        var id = row.data('id');
        var label = row.find('.payment-method-label-input').val();

        if (label === '') {
            return;
        }

        var postData = paymentMethodCsrfData();
        postData.label = label;

        $.post(Storage.getData('app_url') + 'payment-methods/update/' + id, postData, function (r) {
            var data = JSON.parse(r);

            if (data.status == 1) {
                reloadPaymentMethodsList();
            } else {
                $('#payment-method-error').text(data.msg).removeClass('hidden');
            }
        });
    });

    $(document).on('click', '.payment-method-default-dot', function (e) {
        e.preventDefault();

        var dot = $(this);

        if (dot.hasClass('is-default')) {
            return;
        }

        var row = dot.closest('tr');
        var id = row.data('id');

        $('#payment-method-error').addClass('hidden');
        $('#payment-method-success').addClass('hidden');

        $.post(Storage.getData('app_url') + 'payment-methods/set-default/' + id, paymentMethodCsrfData(), function (r) {
            var data = JSON.parse(r);

            if (data.status == 1) {
                $('#payment-methods-tbody .payment-method-default-dot').each(function () {
                    var d = $(this);
                    d.removeClass('is-default').attr('title', d.data('title-not-default'));
                });
                dot.addClass('is-default').attr('title', dot.data('title-default'));

                $('#payment-method-success').text(data.msg).removeClass('hidden');
            } else {
                $('#payment-method-error').text(data.msg).removeClass('hidden');
            }
        });
    });

    var paymentMethodDeleteId = null;

    $(document).on('click', '.payment-method-remove, .admin-payment-method-remove', function (e) {
        e.preventDefault();
        paymentMethodDeleteId = $(this).closest('tr').data('id');
        $('#payment-method-delete-confirm').modal('show');
    });

    $(document).on('click', '#payment-method-delete-confirm-ok', function () {
        var id = paymentMethodDeleteId;
        paymentMethodDeleteId = null;
        $('#payment-method-delete-confirm').modal('hide');

        if (!id) {
            return;
        }

        $.post(Storage.getData('app_url') + 'payment-methods/remove/' + id, paymentMethodCsrfData(), function (r) {
            var data = JSON.parse(r);

            if (data.status == 1) {
                reloadPaymentMethodsList();
            } else {
                var err = $('#payment-method-error');
                if (!err.length) {
                    err = $('#admin-payment-method-error');
                }
                err.text(data.msg).removeClass('hidden');
            }
        });
    });

    $(document).on('click', '#payment-method-delete-confirm-cancel', function () {
        paymentMethodDeleteId = null;
        $('#payment-method-delete-confirm').modal('hide');
    });

    $(document).on('click', '.payment-method-domain-default-save', function (e) {
        e.preventDefault();
        var wrap = $(this).closest('.payment-method-domain-default');
        var did = wrap.data('did');
        var methodId = wrap.find('.payment-method-domain-select').val();
        var postData;

        if ($('#payment-method-csrf').length || $('#admin-payment-method-csrf').length) {
            postData = paymentMethodCsrfData();
        } else {
            var form = $(this).closest('form');
            postData = {
                csrf_token: form.find('input[name="csrf_token"]').val(),
                csrf_token_name: form.find('input[name="csrf_token_name"]').val()
            };
        }

        postData.paymentMethodId = methodId;

        var successEl = wrap.siblings('.payment-method-domain-default-success');
        var errorEl = wrap.siblings('.payment-method-domain-default-error');

        successEl.addClass('hidden');
        errorEl.addClass('hidden');

        $.post(Storage.getData('app_url') + 'payment-methods/set-domain-default/' + did, postData, function (r) {
            var data = JSON.parse(r);

            if (data.status == 1) {
                if (successEl.length) {
                    successEl.text(data.msg).removeClass('hidden');
                }
            } else {
                if (errorEl.length) {
                    errorEl.text(data.msg).removeClass('hidden');
                } else {
                    alert(data.msg);
                }
            }
        });
    });

    $(document).on('change', 'input[name="adminPaymentMethodMode"]', function () {
        var manual = $('input[name="adminPaymentMethodMode"]:checked').val() === 'manual';
        $('#admin-payment-method-card-fields').toggleClass('hidden', manual);
        $('#admin-payment-method-manual-fields').toggleClass('hidden', !manual);
    });

    $(document).on('click', '#adminPaymentMethodAddSubmit', function (e) {
        e.preventDefault();

        var manual = $('input[name="adminPaymentMethodMode"]:checked').val() === 'manual';
        var postData = paymentMethodCsrfData();
        postData.label = $('#adminPaymentMethodLabel').val();
        postData.creditExpirationYear = $('#adminCreditExpirationYear').val();
        postData.creditExpirationMonth = $('#adminCreditExpirationMonth').val();

        var url;
        if (manual) {
            url = 'payment-methods/add-manual';
            postData.token = $('#adminPaymentMethodToken').val();
            postData.last4 = $('#adminPaymentMethodLast4').val();
            postData.brand = $('#adminPaymentMethodBrand').val();
            // Manual token path still needs CVV / ID for later Verify charges.
            var manualCvv = $('#adminCreditCvv').val();
            var manualId = $('#adminCreditId').val();
            var manualErrors = [];
            if (isNaN(manualCvv) || manualCvv.length < 3 || manualCvv.length > 4) {
                manualErrors.push($.translate('cvv is invalid'));
            }
            if (isNaN(manualId) || manualId.length !== 9) {
                manualErrors.push($.translate('id is invalid'));
            }
            if (manualErrors.length) {
                $('#admin-payment-method-error').html(manualErrors.join('<br>')).removeClass('hidden');
                return;
            }
            postData.creditCvv = manualCvv;
            postData.creditId = manualId;
        } else {
            var creditReg = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
            var date = new Date();
            var creditCard = ($('#adminCreditNumber').val() || '').replace(/\D/g, '');
            var creditCardYr = $('#adminCreditExpirationYear').val();
            var creditCardMo = $('#adminCreditExpirationMonth').val();
            var creditCardCvv = $('#adminCreditCvv').val();
            var creditCardId = $('#adminCreditId').val();
            var errors = [];

            if (isNaN(creditCard) || creditCard.length < 8 || creditCard.length > 17 || (!creditReg.test(creditCard) && creditCard.length > 9) || creditCard[0] === '0') {
                errors.push($.translate('card is invalid'));
            }
            if (isNaN(creditCardYr) || parseInt(creditCardYr) < date.getFullYear()) {
                errors.push($.translate('Expiry Year is invalid'));
            } else if (parseInt(creditCardYr) === date.getFullYear() && parseInt(creditCardMo) < (date.getMonth() + 1)) {
                errors.push($.translate('Expiry Month is invalid'));
            }
            if (isNaN(creditCardCvv) || creditCardCvv.length < 3 || creditCardCvv.length > 4) {
                errors.push($.translate('cvv is invalid'));
            }
            if (isNaN(creditCardId) || creditCardId.length !== 9) {
                errors.push($.translate('id is invalid'));
            }

            if (errors.length) {
                $('#admin-payment-method-error').html(errors.join('<br>')).removeClass('hidden');
                return;
            }

            url = 'payment-methods/add';
            postData.creditNumber = creditCard;
            postData.creditCvv = creditCardCvv;
            postData.creditId = creditCardId;
        }

        $('#admin-payment-method-error').addClass('hidden');

        $.post(Storage.getData('app_url') + url, postData, function (r) {
            var data = JSON.parse(r);

            if (data.status == 1) {
                $('#admin-payment-method-error').addClass('hidden');
                $('#adminCreditNumber, #adminCreditCvv, #adminCreditId').val('');
                reloadPaymentMethodsList();
            } else {
                $('#admin-payment-method-error').text(data.msg).removeClass('hidden');
            }
        });
    });

    $(document).on('click', '.admin-payment-method-set-default', function (e) {
        e.preventDefault();
        var id = $(this).closest('tr').data('id');

        $.post(Storage.getData('app_url') + 'payment-methods/set-default/' + id, paymentMethodCsrfData(), function (r) {
            var data = JSON.parse(r);

            if (data.status == 1) {
                reloadPaymentMethodsList();
            } else {
                $('#admin-payment-method-error').text(data.msg).removeClass('hidden');
            }
        });
    });

    $(document).on('click', '#adminPaymentMethodsLimitSave', function (e) {
        e.preventDefault();
        var uid = $(this).data('uid');
        var postData = paymentMethodCsrfData();
        postData.limit = $('#adminPaymentMethodsLimit').val();

        $.post(Storage.getData('app_url') + 'payment-methods/set-limit/' + uid, postData, function (r) {
            var data = JSON.parse(r);

            if (data.status != 1) {
                alert(data.msg);
            }
        });
    });
    $(document).on('click', '.update-contact', function (e) {
        e.preventDefault();
        var uid = $(this).parent().parent().data('uid');
        $.get(Storage.getData('app_url') + 'contacts/update/' + uid, function (r) {
            $.fancybox.open({
                content: r,
                padding: 0,
                type: 'iframe',
                afterShow: function () {
                    $('#saveContact').click(function (e) {
                        e.preventDefault();
                        var form = $(this).closest('form');
                        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var emailEl = form.find('#contactEmail');
                        var priPhoneEl = form.find('#contactLanding');
                        var streetEl = form.find('#contactStreet');
                        var cityEl = form.find('#contactCity');
                        var countryEl = form.find('#contactCountry');
                        var zipEl = form.find('#contactZip');
                        var email = emailEl.val();
                        var street = streetEl.val();
                        var city = cityEl.val();
                        var country = countryEl.val();
                        var zip = zipEl.val();
                        var phone1 = form.find('#tel1').val();
                        var phone2 = form.find('#tel2').val(validatePerf(form.find('#tel2').val())).val();
                        var phone3 = form.find('#tel3').val();
                        var fax1 = form.find('#fax1').val();
                        var fax2 = form.find('#fax2').val(validatePerf(form.find('#fax2').val())).val();
                        var fax3 = form.find('#fax3').val();
                        priPhoneEl.val(phone3 + ' ' + phone2 + ' ' + phone1);
                        form.find('#contactFax').val(fax3 + ' ' + fax2 + ' ' + fax1);
                        var priPhone = priPhoneEl.val();
                        var errors = '';
                        var ct = true;
                        $('#contactEdit input').each(function () {
                            if (!ctype_print($(this).val())) {
                                ct = false;
                            }
                            ;
                        });
                        if (!ct) {
                            errors += $.translate('English Only') + '\n';
                        }
                        if (!re.test(email) || email === '') {
                            emailEl.parent().addClass('has-error');
                            errors += $.translate('Email is invalid') + '\n';
                        }
                        else {
                            emailEl.parent().removeClass('has-error');
                        }
                        if (priPhone === '' || priPhone.length < 13 || !/[0-9\s]+/.test(priPhone)) {
                            priPhoneEl.parent().addClass('has-error');
                            errors += $.translate('Primary phone is required') + '\n';
                        }
                        else {
                            priPhoneEl.parent().removeClass('has-error');
                        }
                        if (street === '' || street.length < 2 || !/[0-9]/.test(street)) {
                            streetEl.parent().addClass('has-error');
                            errors += $.translate('Street is required') + '\n';
                        }
                        else {
                            streetEl.parent().removeClass('has-error');
                        }
                        if (city === '' || city.length < 2 || /[0-9]/.test(city)) {
                            cityEl.parent().addClass('has-error');
                            errors += $.translate('City is required') + '\n';
                        }
                        else {
                            cityEl.parent().removeClass('has-error');
                        }
                        if ($.trim(zip) === '') {
                            zipEl.parent().addClass('has-error');
                            errors += $.translate('Zip is required') + '\n';
                        } else if (!window.isValidZipForCountry(zip, country)) {
                            zipEl.parent().addClass('has-error');
                            errors += $.translate('Zip is invalid') + '\n';
                        } else {
                            zipEl.parent().removeClass('has-error');
                        }
                        if (country === '') {
                            countryEl.parent().addClass('has-error');
                            errors += $.translate('Country is required') + '\n';
                        }
                        else {
                            countryEl.parent().removeClass('has-error');
                        }
                        if (errors !== '') {
                            $('#contact-modal-error').html(nl2br(errors, true)).removeClass('hidden');
                        } else {
                            $('#contact-modal-error').addClass('hidden');
                            $.post($('#contactEdit').attr('action') + '/' + uid, $('#contactEdit').serialize(), function (r) {
                                r = JSON.parse(r);
                                if (r.status == 1) {
                                    $('#contactsflash').html(r.msg).removeClass('hidden');
                                    $('#contact-modal-error').addClass('hidden');
                                    $.fancybox.close();
                                }
                                if (r.status == 0) {
                                    $('#contact-modal-error').html(nl2br(r.msg, true)).removeClass('hidden');
                                }
                            })
                        }

                    })
                }
            });
        });
    });
    $(document).on('click', '.delete-contact', function (e) {
        e.preventDefault();
        var con = confirm($.translate('Are you sure?'));
        if (con) {
            var uid = $(this).parent().parent().data('uid');
            $.get(Storage.getData('app_url') + 'contacts/remove/' + uid, function (r) {
                r = JSON.parse(r);
                if (r.status == 0) {
                    window.location = Storage.getData('app_url') + 'user/login';
                }
                if (r.status == 1) {
                    $.get(Storage.getData('app_url') + '/contacts/list', function (data) {
                        $('#contacts-cont').html(data);
                    })
                }
                if (r.status == 2) {
                    alert(r.msg);
                }
            });
        } else {
            return;
        }
    });
    $(document).on('click', '#addContact', function (e) {
        e.preventDefault();
        $.get(Storage.getData('app_url') + 'contacts/add', function (r) {
            $.fancybox.open({
                content: r,
                padding: 0,
                type: 'iframe',
                afterShow: function () {
                    $('#saveContact').click(function (e) {
                        e.preventDefault();
                        var form = $(this).closest('form');
                        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var emailEl = form.find('#contactEmail');
                        var priPhoneEl = form.find('#contactLanding');
                        var streetEl = form.find('#contactStreet');
                        var cityEl = form.find('#contactCity');
                        var countryEl = form.find('#contactCountry');
                        var zipEl = form.find('#contactZip');
                        var fullNameEl = form.find('#contactFullName');
                        var fullName = fullNameEl.val();
                        var email = emailEl.val();
                        var street = streetEl.val();
                        var city = cityEl.val();
                        var country = countryEl.val();
                        var zip = zipEl.val();
                        var phone1 = form.find('#tel1').val();
                        var phone2 = form.find('#tel2').val(validatePerf(form.find('#tel2').val())).val();
                        var phone3 = form.find('#tel3').val();
                        var fax1 = form.find('#fax1').val();
                        var fax2 = form.find('#fax2').val(validatePerf(form.find('#fax2').val())).val();
                        var fax3 = form.find('#fax3').val();
                        priPhoneEl.val(phone3 + ' ' + phone2 + ' ' + phone1);
                        form.find('#contactFax').val(fax3 + ' ' + fax2 + ' ' + fax1);
                        var priPhone = priPhoneEl.val();
                        var errors = '';
                        var ct = true;
                        form.find('input').each(function () {
                            if (!ctype_print($(this).val())) {
                                ct = false;
                            }
                            ;
                        });
                        if (!ct) {
                            errors += $.translate('English Only') + '\n';
                        }
                        if (fullName === '' || fullName.length < 5 || fullName.split(' ').length < 2) {
                            fullNameEl.parent().addClass('has-error');
                            errors += $.translate('full name is required') + '\n';
                        }
                        else {
                            fullNameEl.parent().removeClass('has-error');
                        }
                        if (!re.test(email) || email === '') {
                            emailEl.parent().addClass('has-error');
                            errors += $.translate('Email is invalid') + '\n';
                        }
                        else {
                            emailEl.parent().removeClass('has-error');
                        }
                        if (priPhone === '' || priPhone.length < 13 || !/[0-9\s]+/.test(priPhone)) {
                            priPhoneEl.parent().addClass('has-error');
                            errors += $.translate('Primary phone is required') + '\n';
                        }
                        else {
                            priPhoneEl.parent().removeClass('has-error');
                        }
                        if (street === '' || street.length < 2 || !/[0-9]/.test(street)) {
                            streetEl.parent().addClass('has-error');
                            errors += $.translate('Street is required') + '\n';
                        }
                        else {
                            streetEl.parent().removeClass('has-error');
                        }
                        if (city === '' || city.length < 2 || /[0-9]/.test(city)) {
                            cityEl.parent().addClass('has-error');
                            errors += $.translate('City is required') + '\n';
                        }
                        else {
                            cityEl.parent().removeClass('has-error');
                        }
                        if ($.trim(zip) === '') {
                            zipEl.parent().addClass('has-error');
                            errors += $.translate('Zip is required') + '\n';
                        } else if (!window.isValidZipForCountry(zip, country)) {
                            zipEl.parent().addClass('has-error');
                            errors += $.translate('Zip is invalid') + '\n';
                        } else {
                            zipEl.parent().removeClass('has-error');
                        }
                        if (country === '') {
                            countryEl.parent().addClass('has-error');
                            errors += $.translate('Country is required') + '\n';
                        }
                        else {
                            countryEl.parent().removeClass('has-error');
                        }
                        if (errors !== '') {
                            form.find('#contact-modal-error').html(nl2br(errors, true)).removeClass('hidden');
                        } else {
                            form.find('#contact-modal-error').addClass('hidden');
                            $.post(form.attr('action'), form.serialize(), function (r) {
                                r = JSON.parse(r);
                                if (r.status == 1) {
                                    //alert(r.msg);
                                    $('#contactsflash').html(nl2br(r.msg, true)).removeClass('hidden');
                                    form.find('#contact-modal-error').addClass('hidden');
                                    $.fancybox.close();
                                }
                                if (r.status == 0) {
                                    form.find('#contact-modal-error').html(nl2br(r.msg, true)).removeClass('hidden');
                                }
                            })
                        }

                    })
                }
            });
        });
    });
    $(document).on('submit', '#user-auth-login form', function (e) {
        $('#user-auth-login-submit').button('loading');
        e.preventDefault();
        $('#upgrade-ntc').addClass('hidden');
        $('#login-errors').addClass('hidden');

        $.post($(this).getFormSubmitPath(), $(this).serialize(), function (data) {
            console.log(data.status);
            if (data.status == 0) {
                $('#user-auth-login-submit').button('reset');
                $('#login-errors').removeClass('hidden').html(data.msg);
            }
            if (data.status == 1) {
                window.location = data.page;
                $.localStorage.set('domains_bulk', []);
                e.stopPropagation();
                return false;
            }
            if (data.status == 2) {
                $('#user-auth-login-submit').button('reset');
                $('#upgrade-ntc').removeClass('hidden');
            }
            if (data.status == 3) {
                $('#user-auth-login-submit').button('reset');
                $('#user-auth-login-email').addClass('disabled');
                $('#user-auth-login-password').addClass('disabled');
                $('#user-auth-login-code').prop('disabled', false);

                $('#form-user-auth-block').addClass('hidden');
                $('#form-user-auth-tfa-block').removeClass('hidden');
            }
        });
    });

    // email verify
    $(document).on('click', '#form-user-auth-email-verify-resend', function (e) {
        e.preventDefault();

        $.post(Storage.getData('app_url') + 'user/email/verify/resend', {}, function (response) {
            if (response.status == 0) {
                $('#email-verify-errors').removeClass('hidden').html(response.msg);
            }
            if (response.status == 1) {
                if(undefined != response.message && undefined != response.message.text && undefined != response.message.title) {
                    $.showSuccess(response.message.title, response.message.text);
                }

                return false;
            }
        });
    });

    $(document).on('submit', '#user-email-verify-form', function (e) {
        $('#user-email-verify-submit').button('loading');
        $('#email-verify-errors').addClass('hidden');
        e.preventDefault();

        $.post($(this).getFormSubmitPath(), $(this).serialize(), function (data) {
            if (data.status == 0) {
                $('#user-email-verify-submit').button('reset');
                $('#email-verify-errors').removeClass('hidden').html(data.msg);
            }
            if (data.status == 1) {
                window.location = Storage.getData('app_url') + 'user/account';
            }
        });
    });

    // redirect from user/account page to search domain page
    $(document).on('submit', '#whois.account-page', function(e) {
        e.preventDefault();

        var inDomain = $('input[name=check-domain]').val();

        if('' == inDomain) {
            return false;
        }
        var normalizedDomain = inDomain.trim()
        .toLowerCase()
        .replace(/^https?:\/\//i, '')  // Remove http:// or https://
        .replace(/^www\./i, '')         // Remove www. prefix
        .replace(/[^\u0590-\u05FF\w\.\-]/g, '');  // Keep only letters (including Hebrew), numbers, dots, hyphens

        // Additional validation: ensure it's not empty after normalization
        if('' == normalizedDomain) {
            return false;
        }
        $(this).find('button').button('loading');

        window.location.href = "/?check-domain=" + encodeURIComponent(normalizedDomain) + 
                          "&csrf_token_name=whois&csrf_token=" + 
                          $(this).find('input[name=csrf_token]').val();
    });

    $(document).on('submit', '#whois:not(.account-page)', whois);
    function whois(e) {
        e.preventDefault();
        $('#check-domain').button('loading');
        var inDomain = $('input[name=check-domain]').val();
        
        // Clean domain: remove protocol, www, paths, ports
        inDomain = inDomain.trim();
        inDomain = inDomain.replace(/^[a-z]+:\/\//i, ''); // Remove protocol
        inDomain = inDomain.replace(/^www\./i, ''); // Remove www
        inDomain = inDomain.split('/')[0]; // Remove path
        inDomain = inDomain.split('?')[0]; // Remove query string
        inDomain = inDomain.split('#')[0]; // Remove hash
        inDomain = inDomain.replace(/:\d+$/, ''); // Remove port
        inDomain = inDomain.toLowerCase();

        window.location.href = "/?check-domain=" + inDomain + "&csrf_token_name=whois&csrf_token=" + $(this).find('input[name=csrf_token]').val();

        return false;
    }

    $(document).on('submit', '#user-auth-password-reset-form', function (e) {
        e.preventDefault();
        $('#user-auth-password-reset-submit').button('loading');
        $('#forgot-errors').addClass('hidden');
        $('#forgot-success').addClass('hidden');
        $.post($(this).attr('action'), $(this).serialize(), function (data) {
            data = JSON.parse(data);
            if (data.status === 0) {
                $('#forgot-errors').removeClass('hidden').html(data.msg);
                $('#user-auth-password-reset-submit').button('reset');
            }
            if (data.status === 1) {
                // todo@alexbuturlakin: Will move "css({'font-size': '15px'})" to less in next commit "enom price and refactoring"
                $('#forgot-success').removeClass('hidden').css({'font-size': '15px'}).html(data.msg);
                $('#user-auth-password-reset-submit').button('reset');
            }
        });
    });


    $(document).on('click', '.option .whoisData', function (e) {
        var data = {
            domain: cur_domain + $(this).data('tld')
        };
        var csrfConfig = Storage.getData('csrf_config');
        var parent     = $(this).closest('.actions');

        data[csrfConfig['token_name_key']] = parent.find('[name=csrf_token_name]').val();
        data[csrfConfig['token_key']]      = parent.find('[name=csrf_token]').val();

        $.post(Storage.getData('app_url') + 'whois/info', data, function (data) {
            e.preventDefault();
            data = data.replace(/&/g, '&amp;')
                .replace(/>/g, '&gt;')
                .replace(/</g, '&lt;')
                .replace(/\n/g, '<br>');
            $.fancybox({
                content: ' <div class="modal-header"><h3>whois</h3></div><div  class="whois_wrap"">' + data + '</div>',
                padding: 0,
                type: 'iframe',
                width: 600
            });
        });
    });


    $(document).on('click', 'a#newSearch', function (e) {
        e.preventDefault();
        $('#alerts_row').addClass('hidden');
        $("#ok").addClass('hidden');
        $("#error").addClass('hidden ');
        $('#re-search-domain').removeClass('hidden');
        $('.hpsearatopr').hide();
        $('.option .progressWhois').show();
        $('.option .avilable').hide();
        $('.option .add_btn').hide();
        $('.option .whoisData').hide();
        $('.option .lblTaken').hide();

    });

	// account type (block-client-type.php): a private account has no company number (disabled = not posted)
	$(document).on('change', '#update-settings .js-settings-client-type', function () {
		var isCompany = 'company' === $(this).val();
		var fields = $('#update-settings .js-settings-company-fields');

		fields.toggleClass('hidden', !isCompany);
		fields.find('input').prop('disabled', !isCompany);
	});

	$(document).on('submit', '#update-settings form', function (e) {
        e.preventDefault();
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var stringRe = /^[A-Za-z\s][A-Za-z0-9\s]*$/;
		var emailEl = $('#registerEmail');
        var passEl = $('#registerPassword');
        var passConfEl = $('#registerPasswordConfirm');
        var fullNameEl = $('#registerFullName');
        var priPhoneEl = $('#registerPrimaryPhone');
        var streetEl = $('#registerAddressStreet');
        var cityEl = $('#registerAddressCity');
        var countryEl = $('#registerAddressCountry');
        var zipEl = $('#registerAddressZip');
        var secondaryPhoneEl = $('#registerSecondaryPhone');
		var email = emailEl.val();
        var pwd = passEl.val();
        var pwdConf = passConfEl.val();
        var fullName = fullNameEl.val();
        var street = streetEl.val();
        var city = cityEl.val();
        var country = countryEl.val();
        var zip = zipEl.val();
        var secondaryPhone = secondaryPhoneEl.val();
        var errors = '';
        var nsvals = [];
		var fax1 = $('#fax1').val();
        var fax2 = $('#fax2').val(validatePerf($('#fax2').val())).val();
        var fax3 = $('#fax3').val();
        var phone1 = $('#tel1').val();
        var phone2 = $('#tel2').val(validatePerf($('#tel2').val())).val();
        var phone3 = $('#tel3').val();
        priPhoneEl.val(phone3 + ' ' + phone2 + ' ' + phone1);
		$('#registerFaxNumber').val(fax3 + ' ' + fax2 + ' ' + fax1);
        var priPhone = priPhoneEl.val();
        var ct = true;
        $('#update-settings input').each(function () {
            if (!ctype_print($(this).val())) {
                ct = false;
            }
            ;
        });
        if (!ct) {
            errors += $.translate('English Only') + '\n';
        }
		if (!re.test(email) || email === '') {
            emailEl.parent().addClass('has-error');
            errors += $.translate('Email is invalid') + '\n';
            $('#email_f .UIValidators >span').text('Email is invalid');
        }
        else {
            emailEl.parent().removeClass('has-error');
        }
        if (fullName === '' || fullName.length < 5 || fullName.split(' ').length < 2) {
            fullNameEl.parent().addClass('has-error');
            errors += $.translate('full name is required') + '\n';
            $('#fullname_f .UIValidators >span').text($.translate('full name is required'));

        }
        else {
            fullNameEl.parent().removeClass('has-error');
        }
        if (priPhone === '' || priPhone.length < 13 || !/[0-9\s]+/.test(priPhone)) {
            priPhoneEl.parent().addClass('has-error');
            errors += $.translate('Primary phone is required') + '\n';
            $('#phone1_f .UIValidators >span').text($.translate('Primary phone is required'));

        }
        else {
            priPhoneEl.parent().removeClass('has-error');
        }
        if (window.isInvalidOptionalPhone(secondaryPhone)) {
            secondaryPhoneEl.parent().addClass('has-error');
            errors += $.translate('Secondary phone is invalid') + '\n';
        } else {
            secondaryPhoneEl.parent().removeClass('has-error');
        }
        if (street === '' || street.length < 2 || !/[0-9]/.test(street)) {
            streetEl.parent().addClass('has-error');
            errors += $.translate('Street is required') + '\n';
            $('#addres_f .UIValidators >span').text($.translate('Street is required with house num'));

        }
        else {
            streetEl.parent().removeClass('has-error');
        }
        if (city === '' || city.length < 2 || /[0-9]/.test(city)) {
            cityEl.parent().addClass('has-error');
            errors += $.translate('City is required') + '\n';
            $('#city_f .UIValidators >span').text($.translate('City is required'));

        }
        else {
            cityEl.parent().removeClass('has-error');
        }
        if ($.trim(zip) === '') {
            zipEl.parent().addClass('has-error');
            errors += $.translate('Zip is required') + '\n';
            $('#zip_f .UIValidators >span').text($.translate('Zip is required'));
        } else if (!window.isValidZipForCountry(zip, country)) {
            zipEl.parent().addClass('has-error');
            errors += $.translate('Zip is invalid') + '\n';
            $('#zip_f .UIValidators >span').text($.translate('Zip is invalid'));
        } else {
            zipEl.parent().removeClass('has-error');
        }
        if (country === '') {
            countryEl.parent().addClass('has-error');
            errors += $.translate('Country is required') + '\n';
        }
        else {
            countryEl.parent().removeClass('has-error');
        }

        var companyIdEl = $('#registerCompanyId');
        if ('company' === $('#update-settings .js-settings-client-type:checked').val()) {
            var companyId = $.trim(companyIdEl.val());

            if (companyId === '') {
                companyIdEl.parent().addClass('has-error');
                errors += $.translate('Company number is required') + '\n';
            } else if (!window.isValidCompanyIdForCountry(companyId, country)) {
                companyIdEl.parent().addClass('has-error');
                errors += $.translate(window.isIsraelCountry(country) ? 'Company ID must be 9 digits starting with 5' : 'Company number is invalid') + '\n';
            } else {
                companyIdEl.parent().removeClass('has-error');
            }
        } else {
            companyIdEl.parent().removeClass('has-error');
        }

		if(pwd !== ''){
			if (pwd.length < 8 /*|| !stringRe.test(pwd)*/) {
				passEl.parent().addClass('has-error');
				if (false/*!stringRe.test(pwd)*/) {
					errors += $.translate('password must contain uppercase lowercase and number characters') + '\n';
				} else {
					errors += $.translate('password is required') + '\n';
					$('#pass_f .UIValidators >span').text($.translate('password is required'));
				}
			} else {
				passEl.parent().removeClass('has-error');
			}

			if (pwd !== pwdConf) {
				passConfEl.parent().addClass('has-error');
				passEl.parent().addClass('has-error');
				errors += $.translate('passwords does not match') + '\n';
				$('#pass_f .UIValidators >span').text($.translate('passwords does not match'));

			} else {
				passConfEl.parent().removeClass('has-error');
				passEl.parent().removeClass('has-error');
			}
		}
        if (errors !== '') {
            $('#update-settings-errors').html(nl2br(errors, true)).removeClass('hidden');
			window.scrollTo(0, 0);
            return false;
        }
        else {
            $('#update-settings-errors').addClass('hidden');
            $('#registerSubmit').button('loading');
            $.post($(this).attr('action'), $(this).serialize(), function (data) {
                data = JSON.parse(data);
                if (data.status === 0) {
                    $('#update-settings-errors').removeClass('hidden').html(nl2br(data.msg, true));
					$('#update-settings-success').addClass('hidden');
					window.scrollTo(0, 0);
                    $('#registerSubmit').button('reset');
                }
                if (data.status === 1) {
                    if (undefined !== data.redirect) {
                        window.location.href = data.redirect;
                    }

                    $('#update-settings-success').removeClass('hidden').html(nl2br(data.msg, true));
					$('#update-settings-errors').addClass('hidden');
					window.scrollTo(0, 0);
					$('#registerSubmit').button('reset');
                }
            });
        }
    });

// +St:
	function setValuesForInput() {
	/*var in_array = $("input[name*='\\[name\\]']");
	$.each( in_array, function(indx, obj) {
		var str = $(obj).val();
		str = str.split('.');
		if( str.length > 4 ) { // serv.protocol.[prior].site.dom => serv.prot.site.dom
		str_out = str[0] + '.' + str[1];
		for(var i=3; i< str.length;i++) str_out += '.' + str[i];
		$(obj).val( str_out );
		}
	});*/
	}
// -St
    // Name servers editor (domain/ns.php): 2 rows shown by default, "+" reveals the next hidden one,
    // "×" clears a row and moves it to the end. Glue IPs are disabled (so not submitted) unless
    // the "Glue records" box is ticked.
    function nsRowsRefresh() {
        var list = $('#manage-ns-records');
        var visible = list.find('.ns-row').not('.hidden');

        visible.each(function (i) {
            $(this).find('.ns-row-num > span').text(i + 1);
        });
        // At least 2 name servers are required, so the first two can't be removed.
        list.toggleClass('ns-can-remove', visible.length > 2);
        $('#ns-add-row').toggleClass('hidden', 0 === list.find('.ns-row.hidden').length);
    }

    $(document).on('click', '#ns-add-row', function (e) {
        e.preventDefault();
        var row = $('#manage-ns-records .ns-row.hidden').first();
        row.removeClass('hidden');
        nsRowsRefresh();
        row.find('input[name$="[ns]"]').focus();
    });

    $(document).on('click', '#manage-ns-records .ns-row-remove', function (e) {
        e.preventDefault();
        var row = $(this).closest('.ns-row');
        row.find('input').val('');
        row.addClass('hidden').appendTo(row.parent());
        nsRowsRefresh();
    });

    $(document).on('change', '#ns-glue-check', function () {
        var on = $(this).is(':checked');
        $('#manage-ns-records').toggleClass('has-glue', on)
            .find('.ns-row-glue input').prop('disabled', !on);
    });

    $(document).on('click', '.manage', function (e) {
        e.preventDefault();
        var el = $(this);
        if (el.is(':disabled') || el.prop('disabled')) {
            return;
        }
        var uid = el.closest('tr').data('uid');
        var url = Storage.getData('app_url') + 'domain/manageDomain/' + uid;
        $.getJSON(url, null, function (r) {
            if (r.status == 0) {
                // alert(r.msg);
                //$('#main-content').html(r.msg);
                $.fancybox.open({
                    content: '<div class="error-fanc">' + r.msg + '</div>',
                    padding: 0,
                    
                });
            }
            if (r.status == 1) {
                $.fancybox.open({
                    content: r.msg,
                    padding: 0,
                    type: 'iframe',
                    afterShow: function () {

                        $('#ns-reset-default').click(function() {

                            var rawNs = $('#default-box-ns').text();
                            var defaults;
                            try {
                                defaults = eval('(' + rawNs + ')');
                            } catch(e) {
                                console.log("Invalid Default NS");
                                return;
                            }
                            $('#manage-ns-records .ns-row').each(function(i) {

                                if (defaults[i]) {
                                    $(this).find('input[name$="[ns]"]').val(defaults[i]);
                                } else {
                                    $(this).find('input[name$="[ns]"]').val('');
                                }

                                $(this).find('input[name$="[ip]"]').val('');
                                $(this).find('input[name$="[ipv6]"]').val('');
                                $(this).toggleClass('hidden', i >= Math.max(2, defaults.length));
                            });
                            $('#ns-glue-check').prop('checked', false).trigger('change');
                            nsRowsRefresh();
                            $('#ns-reset-default-after-click').removeClass('hide');
                        });

                        $('#updatens').submit(function (e) {
                            e.preventDefault();
                            $('#save-ns').button('loading');
                            $.post(url, $(this).serialize(), function (r) {
                                r = JSON.parse(r);
                                if (r.status == 0) {
                                    $.fancybox.close();
                                    $('#main-content').html(r.msg);
                                    updateUrl(r.title, r.page);

                                    setValuesForInput();
                                }
                                if (r.status == 1) {
                                    $('#domainflash').html(r.msg).removeClass('hidden');
                                    $.fancybox.close();
                                }
                                if (r.status == 2) {
                                    $('#ns-errors').html(r.msg).removeClass('hidden');
                                    $('#save-ns').button('reset');
                                }
                            })
                        });

                        $('#manage-ns-dnssec-add-button').click(function(e) {
                            e.preventDefault();
                            $(this).addClass('hidden');
                            $('#manage-ns-dnssec-create-section').removeClass('hidden');
                            $('#manage-ns-dnssec-save-button').removeClass('hidden');
                            $('#manage-ns-dnssec-cancel-button').removeClass('hidden');
                        });

                        $('#manage-ns-dnssec-cancel-button').click(function(e) {
                            e.preventDefault();
                            $(this).addClass('hidden');
                            $('#manage-ns-dnssec-create-section').addClass('hidden');
                            $('#manage-ns-dnssec-save-button').addClass('hidden');
                            $('#manage-ns-dnssec-add-button').removeClass('hidden');
                        });

                        $('#dnssec-create').submit(function (e) {
                            e.preventDefault();
                            $('#manage-ns-dnssec-save-button').button('loading');
                            $('#manage-ns-dnssec-cancel-button').prop('disabled', 'disabled');

                            $.post($(this).attr('action'), $(this).serialize())
                              .done(function (response) {
                                  $('#manage-ns-dnssec-save-button').button('reset');
                                  $('#manage-ns-dnssec-cancel-button').prop('disabled', false);
                                  $('#manage-ns-dnssec-errors').html('').addClass('hidden');
                                  $('#dnssec-create').resetForm();

                                  let emptyRow = $('#manage-ns-dnssec-records .manage-ns-dnssec-record-empty');

                                  if (0 !== emptyRow.length) {
                                      emptyRow.remove();
                                  }

                                  $('#manage-ns-dnssec-cancel-button').click();

                                  if (0 === $('#manage-ns-dnssec-records > tbody > tr').length) {
                                      $('#manage-ns-dnssec-records > tbody').append(response.tableRow);
                                  } else {
                                      $(response.tableRow).insertBefore('#manage-ns-dnssec-records > tbody > tr:first');
                                  }
                              })
                              .fail(function(response) {
                                  if (403 === response.status) {
                                      window.location.href = '/user/login';
                                  }

                                  $('#manage-ns-dnssec-errors').html(response.responseJSON.error).removeClass('hidden');
                                  $('#manage-ns-dnssec-save-button').button('reset');
                                  $('#manage-ns-dnssec-cancel-button').prop('disabled', false)
                              })
                        });

                        $('#manage-ns-dnssec-records').on('click', '.manage-ns-dnssec-record-delete', function(e) {
                            e.preventDefault();

                            let link = $(this);

                            $.ajax({
                                url: link.attr('href'),
                                type: 'DELETE',
                                success: function(response) {
                                    link.parent().parent().remove();
                                    $('#manage-ns-dnssec-base-errors').html('').addClass('hidden');

                                    if (0 === response.totalRows) {
                                        $('#manage-ns-dnssec-records > tbody').append(response.emptyRow);
                                    }
                                },
                                error: function(xhr) {
                                    if (403 === xhr.status) {
                                        window.location.href = '/user/login';
                                    }

                                    $('#manage-ns-dnssec-base-errors').html(xhr.responseJSON.error).removeClass('hidden');
                                }
                            });
                        });

                    }
                });
            }
			setValuesForInput();
        });
    });

    $(document).on('click', '.enom-raa-resend', function (e) {
        e.preventDefault();
        var el = $(this);
        if (el.is(':disabled') || el.data('busy')) {
            return;
        }

        var uid = el.data('uid') || el.closest('tr').data('uid');
        if (!uid) {
            return;
        }

        var url = el.data('url') || (Storage.getData('app_url') + 'domain/enom-raa-resend/' + uid);

        el.data('busy', true).prop('disabled', true);

        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json'
        }).done(function (r) {
            var msg = (r && r.msg) ? r.msg : '';
            if (r && r.status == 1) {
                $.showSuccess(r.title || $.translate('Success'), msg, false, true);
            } else {
                $.showError(msg || $.translate('Failed to resend verification email. Please contact support.'));
            }
        }).fail(function () {
            $.showError($.translate('Failed to resend verification email. Please contact support.'));
        }).always(function () {
            el.data('busy', false).prop('disabled', false);
        });
    });

    $(document).on('click', '#transfer', function (e) {
        e.preventDefault();
        $.get(Storage.getData('app_url') + 'domain/transferDomain', function (r) {
            $.fancybox.open({
                content: r,
                type: 'iframe',
                padding: 0,
                afterShow: function () {
                    $('.show-tooltip').addTooltip();

                    $('.panel-default a').click(function () {
                        $('.collapse').collapse('toggle');
                    })
                    var btn = $('#transfer-domain');
                    $('#transfer-domain').click(function (e) {
                        var sld = $('#domain-sld').val();
                        var tld = $('#domain-tld').val();
                        var admin = $('#ownerTransfer').val();
                        var tech = $('#techTransfer').val();
                        var zone = $('#adminTransfer').val();
                        var form = $(this).closest('form');

                        btn.button('loading');
                        e.preventDefault();

                        var csrfConfig = Storage.getData('csrf_config');
                        var data = {
                            sld: sld,
                            tld: tld,
                            admin: admin,
                            adminIsoc: $('option[value="' + admin + '"]').data('isoc-id'),
                            tech: tech,
                            techIsoc: $('option[value="' + tech + '"]').data('isoc-id'),
                            zone: zone,
                            zoneIsoc: $('option[value="' + zone + '"]').data('isoc-id'),
                            eppCode: $('#domain-transfer-isoc-epp').val()
                        };


                        data[csrfConfig['token_name_key']] = form.find('[name=csrf_token_name]').val();
                        data[csrfConfig['token_key']]      = form.find('[name=csrf_token]').val();

                        $.post(Storage.getData('app_url') + 'domain/transferDomain', data, function (r) {
                            r = JSON.parse(r);
                            if (r.status == 0) {
                                $('#transfer-modal-error').html(r.msg).removeClass('hidden');
                                $('button').button('reset');
                            }
                            if (r.status == 1) {
                                $.fancybox.close();
                                $('#mDomains').click();
                                $('#domainflash').html(r.msg).removeClass('hidden');
                            }
                        });
                    });
                    var transferSubmitting = false;
                    $('#transfer-enom-domain').click(function (e) {
                        e.preventDefault();
                        var form = $('#transferForm');
                        if (transferSubmitting) return;
                        $('#transfer-modal-error').addClass('hidden');
                        $('#transfer-enom-domain').button('loading');
                        var creditReg = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
                        var creditCardEl = form.find('#creditNumber');
                        var creditYrEl = form.find('#creditExpirationYear');
                        var creditMoEl = form.find('#creditExpirationMonth');
                        var creditCardCvvEl = form.find('#creditCvv');
                        var creditIdEl = form.find('#creditId');
                        var date = new Date();
                        var creditCard = creditCardEl.val();
                        var creditCardYr = creditYrEl.val();
                        var creditCardMo = creditMoEl.val();
                        var creditCardCvv = creditCardCvvEl.val();
                        var creditCardId = creditIdEl.val();
                        var approve_termsEl = form.find('#approve_terms');
                        var approve_terms = approve_termsEl.is(":checked");
                        var paymentMethodEl = form.find('#paymentMethodId');
                        var usingSavedPaymentMethod = paymentMethodEl.length > 0 && paymentMethodEl.val();
                        var errors = '';
                        if ($('[name="enomDomainTransfer"]').val() == '' || $('[name="enomDomainTransfer"]').val().split('.').length < 2) {
                            errors += $.translate('You must enter domain name') + '\n';
                        }
                        if ($('[name="domainEPPTransfer"]').val() == '' || !enom_ctype_print($('[name="domainEPPTransfer"]').val())) {
                            errors += $.translate('You must enter valid EPP code') + '\n';
                        }
                        var enomOwnerTransferEl = $('#enomOwnerTransfer');
                        if (!enomOwnerTransferEl.val() || enomOwnerTransferEl.val() == '') {
                            enomOwnerTransferEl.parent().addClass('has-error');
                            errors += $.translate('You must select a contact') + '\n';
                        } else {
                            enomOwnerTransferEl.parent().removeClass('has-error');
                        }
                        if (!approve_terms) {
                            approve_termsEl.parent().addClass('has-error');
                            errors += $.translate('Approve Terms is required') + '\n';
                        }
                        else {
                            approve_termsEl.parent().removeClass('has-error');
                        }
                        if (usingSavedPaymentMethod) {
                            creditYrEl.parent().removeClass('has-error');
                            creditMoEl.parent().removeClass('has-error');
                            creditCardCvvEl.parent().removeClass('has-error');
                            creditIdEl.parent().removeClass('has-error');
                            creditCardEl.parent().removeClass('has-error');
                        } else {
                        if (isNaN(creditCardYr) || parseInt(creditCardYr) < date.getFullYear()) {
                            creditYrEl.parent().addClass('has-error');
                            errors += $.translate('Expiry Year is invalid');
                        }
                        else {
                            creditYrEl.parent().removeClass('has-error');
                        }
                        if (isNaN(creditCardMo) || creditCardYr == date.getFullYear() && creditCardMo < date.getMonth()) {
                            creditMoEl.parent().addClass('has-error');
                            errors += $.translate('Expiry Month is invalid') + '\n';
                        }
                        else {
                            creditMoEl.parent().removeClass('has-error');
                        }
                        if (isNaN(creditCardCvv) || creditCardCvv.length < 3 || creditCardCvv.length > 4) {
                            creditCardCvvEl.parent().addClass('has-error');
                            errors += $.translate('cvv is invalid') + '\n';
                        }
                        else {
                            creditCardCvvEl.parent().removeClass('has-error');
                        }
                        if (isNaN(creditCardId) || creditCardId.length < 9 || creditCardId.length > 9) {
                            creditIdEl.parent().addClass('has-error');
                            errors += $.translate('id is invalid') + '\n';
                        }
                        else {
                            creditIdEl.parent().removeClass('has-error');
                        }
                        if (isNaN(creditCard) || creditCard.length < 9 || creditCard.length > 17 || !creditReg.test(creditCard) && creditCard.length > 9 || creditCard[0] === 0) {
                            creditCardEl.parent().addClass('has-error');
                            errors += $.translate('card is invalid') + '\n';
                        }
                        else {
                            creditCardEl.parent().removeClass('has-error');
                        }
                        }
                        if (errors != '') {
                            $('#transfer-modal-error').html(nl2br(errors)).removeClass('hidden');
                            $('#transfer-enom-domain').button('reset');
                        } else {
                            transferSubmitting = true;
                            $.post(Storage.getData('app_url') + 'domain/transferEnom', $('#transferForm').serialize(), function (r) {
                                r = JSON.parse(r);
                                if (r.status == 0) {
                                    transferSubmitting = false;
                                    $('#transfer-modal-error').html(nl2br(r.msg)).removeClass('hidden');
                                    $('#transfer-enom-domain').button('reset');
                                }
                                if (r.status == 1) {
                                    $('#domainflash').html(nl2br(r.msg)).removeClass('hidden');
                                    $('#transfer-enom-domain').button('reset');
                                    $.fancybox.close();
                                }
                            }).fail(function () {
                                transferSubmitting = false;
                                $('#transfer-enom-domain').button('reset');
                            });
                        }
                    })
                }
            });
        });
    });
    $(document).on('click', '#isLockCheck', function (e) {
        e.preventDefault();
        var domain = '';

        if ($('#collapseEnom').hasClass('in')) {
            domain = $('#enomDomainTransfer').val();
        }

        if ($('#israeliTranCollapse').hasClass('in') && '' !== $('#domain-sld').val()) {
            domain = $('#domain-sld').val() + '.' + $('#domain-tld').val();
        }

        if ('' === domain) {
            return;
        }

        var url = $(this).attr('href');

        $('#isLockRes').html('').addClass('hidden');
        if (domain == '') {
            $('#transfer-modal-error').html($.translate('please fill domain')).removeClass('hidden');
            //alert(appLocale['please fill domain']);
            return false;
        }
        $('#transfer-modal-error').addClass('hidden');
        $.getJSON(url + domain, function (r) {
            if (r.status == 0) {
                //alert(r.msg);
                $('#transfer-modal-error').html(r.msg).removeClass('hidden');
            }
            if (r.status == 1) {
                $('#isLockRes').html(r.msg).removeClass('hidden');
            }
        });
    });
   
    /**
    $(document).on('click', '.lock', function (e) {
        e.preventDefault();
        var el = $(this);
        var uid = el.parent().parent().data('uid');
        var url = Storage.getData('app_url') + 'domain/lockDomain/' + uid;
        $.getJSON(url, null, function (r) {
            if (r.status == 0) {
                $('#main-content').html(r.msg);
            }
            if (r.status == 1) {
                $.fancybox.open({
                    content: r.msg,
                    padding: 0,
                    type: 'iframe',
                    afterShow: function () {
                        var btn = $('#save-lock');
                        $('#updatelock').submit(function (e) {
                            e.preventDefault();
                            btn.button('loading');

                            var data = {
                                lockstate: $('input[name="lockstate"]:checked').val()
                            };

                            var csrfConfig = Storage.getData('csrf_config');

                            data[csrfConfig['token_name_key']] = $(this).find('[name=csrf_token_name]').val();
                            data[csrfConfig['token_key']]      = $(this).find('[name=csrf_token]').val();

                            $.post(url, data, function (r) {
                                r = JSON.parse(r);
                                if (r.status == 0) {
                                    $('#main-content').html(r.msg);
                                    $.fancybox.close();
                                }
                                if (r.status == 1) {
                                    alert(r.msg);
                                    $.fancybox.close();
                                }
                            });
                        });
                    }
                });
            }
        });
    });
    */
    


    $(document).on('click', '.renew', function (e) {
        e.preventDefault();
        var el = $(this);
        var uid = el.closest('tr').data('uid');
        var url = Storage.getData('app_url') + 'domain/renewDomain/' + uid;
        $.getJSON(url, null, function (r) {
            if (r.status == 0) {
                $('#main-content').html(r.msg);
            }
            if (r.status == 1) {
                $.fancybox.open({
                    content: r.msg,
                    padding: 0,
                    type: 'iframe',
                    afterShow: function () {
                        $('.show-tooltip').addTooltip();
                    },
                    beforeClose: function () {
                        $('#domain-renew-confirm-pending').modal('hide');
                    }
                });
            }
        });
    });

    $('#main-content.page-domain-renew #renew-domain .cvvhelp').hover(function () {
        $(this).find('img').show();
    }, function () {
        $(this).find('img').hide();
    });

    var renewSubmitting = false;
    $(document).on('click', '#renew-domain #renew', function(e) {
        if (renewSubmitting) return;
        $(this).button('loading');
    });

    $(document).on('click', '#domain-renew-confirm-confirm', function() {
        $('#domain-renew-confirm-pending').modal('hide');
        $('#domain-renew-pending-confirmed').val(1);
        $('#renew').trigger('click');
    });

    $(document).on('click', '#domain-renew-confirm-cancel', function() {
        $('#domain-renew-confirm-pending').modal('hide');
    });

    $(document).on('submit', '#renew-domain', function (e) {
        var form = $(this);
        var btn = form.find('#renew');
        e.preventDefault();

        // d0ger easy
        var creditReg = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;
        var creditCardEl = form.find('#creditNumber');
        var creditYrEl = form.find('#creditExpirationYear');
        var creditMoEl = form.find('#creditExpirationMonth');
        var creditCardCvvEl = form.find('#creditCvv');
        var creditIdEl = form.find('#creditId');
        var domainPeriodEl = form.find('#domainPeriod');
        var date = new Date();
        var creditCard = creditCardEl.val();
        var creditCardYr = creditYrEl.val();
        var creditCardMo = creditMoEl.val();
        var creditCardCvv = creditCardCvvEl.val();
        var creditCardId = creditIdEl.val();
        var domainPeriod = parseInt(form.find('[name=domainPeriod]:checked').val());
        var approve_termsEl = form.find('#approve_terms');
        var approve_terms = approve_termsEl.is(":checked");
        var paymentMethodEl = form.find('#paymentMethodId');
        var usingSavedPaymentMethod = paymentMethodEl.length > 0 && paymentMethodEl.val();
        var errors = '';
        if(approve_terms != undefined) {
            if (!approve_terms) {
                approve_termsEl.parent().addClass('has-error');
                errors += $.translate('Approve Terms is required') + '\n';
                //$('#zip_f .UIValidators >span').text(appLocale['Approve Terms is required']);
            }
            else {
                approve_termsEl.parent().removeClass('has-error');
            }
        }

        if (usingSavedPaymentMethod) {
            creditYrEl.parent().removeClass('has-error');
            creditMoEl.parent().removeClass('has-error');
            creditCardCvvEl.parent().removeClass('has-error');
            creditIdEl.parent().removeClass('has-error');
            creditCardEl.parent().removeClass('has-error');
        } else {
        if (isNaN(creditCardYr) || parseInt(creditCardYr) < date.getFullYear()) {
            creditYrEl.parent().addClass('has-error');
            errors += $.translate('Expiry Year is invalid');
        }
        else {
            creditYrEl.parent().removeClass('has-error');
        }
        if (isNaN(creditCardMo) || creditCardYr == date.getFullYear() && creditCardMo < date.getMonth()) {
            creditMoEl.parent().addClass('has-error');
            errors += $.translate('Expiry Month is invalid') + '\n';
        }
        else {
            creditMoEl.parent().removeClass('has-error');
        }
        if (isNaN(creditCardCvv) || creditCardCvv.length < 3 || creditCardCvv.length > 4) {
            creditCardCvvEl.parent().addClass('has-error');
            errors += $.translate('cvv is invalid') + '\n';
        }
        else {
            creditCardCvvEl.parent().removeClass('has-error');
        }
        if (isNaN(creditCardId) || creditCardId.length < 9 || creditCardId.length > 9) {
            creditIdEl.parent().addClass('has-error');
            errors += $.translate('id is invalid') + '\n';
        }
        else {
            creditIdEl.parent().removeClass('has-error');
        }
        if (isNaN(creditCard) || creditCard.length < 9 || creditCard.length > 17 || !creditReg.test(creditCard) && creditCard.length > 9 || creditCard[0] === 0) {
            creditCardEl.parent().addClass('has-error');
            errors += $.translate('card is invalid') + '\n';
        }
        else {
            creditCardEl.parent().removeClass('has-error');
        }
        }
        if (domainPeriod < 1 && domainPeriod > 5) {
            domainPeriodEl.parent().addClass('has-error');
            errors += $.translate('Domain Period is invalid') + '\n';
        }
        else {
            domainPeriodEl.parent().removeClass('has-error');
        }
        if (errors !== '') {
            $('#renew-errors').html(nl2br(errors, true)).removeClass('hidden');
            btn.button('reset');
            return false;
        } else {
            $('#renew-errors').addClass('hidden');
        }
        renewSubmitting = true;
        var uid = $('#renew-domain').data('uid');
        var url = Storage.getData('app_url') + 'domain/renewDomain/' + uid;
        var postData = $(this).serialize();

        postData['destination'] = '/user/account';

        $.ajax({
            url:   url,
            data:  postData,
            type: 'post',
            error: function(XMLHttpRequest, textStatus, errorThrown){
                renewSubmitting = false;
                btn.button('reset');
                window.location.href = '/user/login';
            },
            success: function (r) {
                if (r.status == 0) {
                    if(undefined != r.premiumPrice) {
                        // show warning
                        $('#renew-domain-is-premium').removeClass('hidden').html(r.msg);

                        // update form
                        $('#domain-purchase-is-premium').val(1);

                        // update price
                        var priceEl = $('#renew-domain').find('span.UIInfoTitle');

                        for (var year in r.premiumPrice) {
                            priceEl.attr('data-price-{0}'.format(year), r.premiumPrice[year]);
                        }

                        var period = parseInt($('#renew-domain input[name=domainPeriod]:checked').val());
                        var price  = 0;

                        // update total price
                        for (var i = 1; i < period + 1; i++) {
                            var yearPrice = priceEl.attr('data-price-{0}'.format(i));

                            if (undefined !== yearPrice) {
                                price += parseFloat(yearPrice);
                            }
                        }

                        priceEl.find('span').html(Number(price).toFixed(2));

                        var checked = $('#renew-domain input[name=domainPeriod]:checked');
                        $('#renew-domain input[name=domainPeriod]:first').trigger('click');

                        if (checked.length > 0) {
                            checked.trigger('click');
                        }

                        $('#couponCode').val('');
                        $('#cpnDis').addClass('hidden');
                    } else if (
                      undefined !== r.format
                      && undefined !== r.type
                      && 'popin' === r.format
                      && 'pendingRenew'  === r.type
                    ) {
                        if (0 !== $('#domain-renew-confirm-pending').length) {
                            $('#domain-renew-confirm-pending').modal('show');
                        } else {
                            $(r.msg).modal('show');
                        }
                    } else {
                        if(typeof undefined === typeof r.destination) {
                            $('#renew-errors').html(nl2br(r.msg, true)).removeClass('hidden');
                        } else {
                            window.location.href = r.destination;
                        }
                    }

                    renewSubmitting = false;
                    $('#renew').button('reset');
                }

                if (r.status == 1) {
                    $('#domainflash').html(nl2br(r.msg, true)).removeClass('hidden');
                    $.fancybox.close();

                    $.fancybox.open({
                        content: r.msg,
                        padding: 0,
                        type: 'iframe',
                        afterShow: function () {
                            var btn = $('#good_renew');
                            btn.click(function(){
                                $.fancybox.close();

                                if(typeof undefined === typeof r.destination) {
                                    window.location.href = window.location.href;
                                } else {
                                    window.location.href = r.destination;
                                }

                            });
                        },
                        afterClose: function () {
                            if(typeof undefined === typeof r.destination) {
                                window.location.href = window.location.href;
                            } else {
                                window.location.href = r.destination;
                            }
                        }
                    });
                }
            }
        });
    });

    /*main menu*/
    $('.menu>ul>li').mouseenter(function () {
      $('.menu>ul>li').find('.sub-menu').stop().fadeOut();

      var el = $(this);

      el.addClass('active').find('.sub-menu').fadeIn();

      // setTimeout(function() {
      //
      // }, 300);
    });

    $('.menu>ul>li').mouseleave(function () {
      var el = $(this);
      $('.menu>ul>li').find('.sub-menu').stop().hide();

      el.removeClass('active').find('.sub-menu').fadeOut();
    });

    // Mobile Menu Click*
    $(document).on('click','#mobileMenu > li > a',function(){
        $('.sub-menu').fadeOut();
        if($(this).parent().hasClass('active')){
            $(this).parent().removeClass('active');
        }else{
            $(this).parent().addClass('active');
            $(this).parent().find('.sub-menu').fadeIn();
        }

    })


    $(".fancybox-video").click(function () {
        $.fancybox({
            'padding': 0,
            'autoScale': false,
            'transitionIn': 'none',
            'transitionOut': 'none',
            'title': this.title,
            'width': 640,
            'height': 385,
            'href': this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
            'type': 'swf',
            'swf': {
                'wmode': 'transparent',
                'allowfullscreen': 'true'
            }
        });

        return false;
    });

    $(document).on('change', '#renew-domain input[name=domainPeriod]', function () {
        var title       = $('#renew-domain').find('span.UIInfoTitle'),
            // price       = parseFloat(title.data('price')),
            // secondPrice = parseFloat(title.data('second-price')),
            price       = 0,
            period      = parseInt($(this).val()),
            form        = $(this).closest('form'),
            creDetails  = form.find('#creditDetails');


        form.find('#creditExpirationYear').find('option').eq(0).prop('selected', true);
        form.find('#creditExpirationMonth').find('option').eq(0).prop('selected', true);
        form.find('#creditCvv').val('');
        form.find('#creditId').val('');
        form.find('#creditNumber').val('');
        $('#cpn-error').addClass('hidden');
        $('#cpnDis').addClass('hidden');
        creDetails.find('input[type=text]').parent().show();
        creDetails.find('select').parent().show();
        $('#checkCoupon').prop('disabled', false);

        // update total price
        for (var i = 1; i < period + 1; i++) {
            var yearPrice = title.attr('data-price-{0}'.format(i));

            if (undefined !== yearPrice) {
                price += parseFloat(yearPrice);
            }
        }

        title.find('span').html(Number(price).toFixed(2));
    });

    $(document).on('keyup', '#enomDomainTransfer', function () {
        $('#enomPricing').hide()
    });

    $(document).on('click', '#enomCalculatePrice', function (e) {
        e.preventDefault();
        $('#transfer-modal-error').addClass('hidden');
        $('#enomPricing').hide();
        $('#enomCalculatePrice').button('loading');

        var csrfConfig = Storage.getData('csrf_config');
        var form       = $(this).closest('form');
        var data       = {
            enomDomainTransfer: $('#enomDomainTransfer').val()
        };


        data[csrfConfig['token_name_key']] = form.find('[name=csrf_token_name]').val();
        data[csrfConfig['token_key']]      = form.find('[name=csrf_token]').val();

        $.post(Storage.getData('app_url') + 'domain/enomcheck', data, function (r) {
            r = JSON.parse(r);
            if (r.status == 0) {
                $('#transfer-modal-error').html(nl2br(r.msg, true)).removeClass('hidden');
                $('#enomCalculatePrice').button('reset');
            }
            if (r.status == 1) {
                $('#domainBasePricing .amount').html(r.msg);
                $('#enomPricing').show();
                $('#enomCalculatePrice').button('reset');
                $('.show-tooltip').addTooltip();
            }
        })
    });

    $(document).on('click', '#enomPricing #checkCoupon', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var cpn = $('#couponCode').val();
        $('#cpn-error').addClass('hidden');
        //$('#cpnDis').addClass('hidden');
        $(this).button('loading');
        form.find('#creditDetails input[type=text]').parent().show();
        form.find('#creditDetails select').parent().show();
        form.find('#creditNumber').val('').trigger('change').trigger('keyup.jccv');
        form.find('#creditExpirationYear option').eq(0).prop('selected', true);
        form.find('#creditExpirationMonth option').eq(0).prop('selected', true);
        form.find('#creditCvv').val('');
        form.find('#creditId').val('');
        $.get(Storage.getData('app_url') + 'checkCpn/' + cpn, '', function (r) {
            r = parseFloat(r);
            if (r <= 0) {
                $('#cpn-error').removeClass('hidden');
                $('#cpnDis').addClass('hidden');
            } else {
                $('#cpn-error').addClass('hidden');
                var price = $('#domainBasePricing span').html();
                var dis = price - r;
                if (dis <= 0) {
                    dis = 0;
                    form.find('#creditDetails input[type=text]').parent().hide();
                    form.find('#creditDetails select').parent().hide();
                    form.find('#creditNumber').val('378282246310005');
                    form.find('#creditExpirationYear').val(new Date().getFullYear() + 5);
                    form.find('#creditExpirationMonth').val(12);
                    form.find('#creditCvv').val(123);
                    form.find('#creditId').val(123456789);
                }
                $('.amount').html(price);
                $('.sum').html(Number(dis).toFixed(2))
                $('#cpnDis').removeClass('hidden');
            }
            $('#checkCoupon').button('reset');
        });
        $('#checkCoupon').button('reset');
    });
    $(document).on('click', '#search', function (e) {
        e.preventDefault();
        var q = $.getQueryParameters();
        var sq = $('#sq').val();
        var baseUrl = document.location.href.replace(window.location.search, '?');
        q.q = sq;
        if (sq == '') {
            delete q.q;
        }
        document.location.replace(baseUrl + $.param(q));
    });

    // this code was inlined in main.php file
    // cc card validation callback
    if($('#creditNumber.validate').length) {
        $('#creditNumber.validate').validateCreditCard(function (result) {
            var input = $(this);
            var type  = null == result.card_type ? 'type-none' : 'type-' + result.card_type.name;
            var cvv   = input.closest('form').find('#creditCvv.validate');

            // set classes
            input.removeClassPrefix('type-');
            input.addClass(type);
            result.valid ? input.addClass('valid') : input.removeClass('valid');

            // set cvv length
            if(cvv.length > 0) {
                var maxLen = null != result.card_type && 'amex' == result.card_type.name ? 4 : 3;
                cvv.attr('maxlength', maxLen);
            }
        });
    }

    $(document).on('click', '#admin-domain-sent-owner-verify-email', function (e) {
        e.preventDefault();

        var el = $(this);

        $.ajax({
            url: el.attr('href'),
            type: 'POST',
            data: {
                'email': $('#ownerEmail').val()
            },
            success: function (response) {
                if (0 == response.status) {
                    $('#admin-domain-sent-owner-verify-email-errors').html(nl2br(response.msg, true)).removeClass('hidden');
                }

                if (1 == response.status) {

                    console.log('OPA');
                    console.log('OPA');
                    console.log(el.attr('data-destination'));
                    console.log(el.data('destination'));

                    window.location.href = el.attr('data-destination');
                }
            },
            error: function (xhr) {
                if (403 === xhr.status) {
                    window.location.href = '/user/login';
                }

                $('#admin-domain-sent-owner-verify-email-errors').html(xhr.responseJSON.error).removeClass('hidden');
            }
        });
    });

    const $dropdown_support = $("#supportMenu-dropDown");
	const $icon_support = $('#supportMenu i');
	$('#supportMenu').on('click', function () {
		if ($dropdown_support.is(':visible')) {
			$dropdown_support.slideUp(150);
			$icon_support.removeClass('fa-chevron-up').addClass('fa-chevron-down');
		}else{
			$dropdown_support.slideDown(150);
			$icon_support.removeClass('fa-chevron-down').addClass('fa-chevron-up');
		}
		$("#manageMenu-dropDown").slideUp(150);
		$('#manageMenu i').removeClass('fa-chevron-up').addClass('fa-chevron-down');

	});
	
	const $dropdown_manage = $("#manageMenu-dropDown");
	const $icon_manage = $('#manageMenu i');
	$('#manageMenu').on('click', function () {
		if ($dropdown_manage.is(':visible')) {
			$dropdown_manage.slideUp(150);
			$icon_manage.removeClass('fa-chevron-up').addClass('fa-chevron-down');
		}else{
			$dropdown_manage.slideDown(150);
			$icon_manage.removeClass('fa-chevron-down').addClass('fa-chevron-up');
		}
		$("#supportMenu-dropDown").slideUp(150);
		$('#supportMenu i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
	});

    $(document).on('click', function (e) {
        // אם הלחיצה לא הייתה בתוך #supportMenu או #supportMenu-dropDown
        if (!$(e.target).closest('#supportMenu, #supportMenu-dropDown').length) {
            $("#supportMenu-dropDown").slideUp(150);
            $('#supportMenu i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }

        // אם הלחיצה לא הייתה בתוך #manageMenu או #manageMenu-dropDown
        if (!$(e.target).closest('#manageMenu, #manageMenu-dropDown').length) {
            $("#manageMenu-dropDown").slideUp(150);
            $('#manageMenu i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
    });

    // tooltips
    $('.show-tooltip').addTooltip();

    function isValidIPv4(ip) {
        return /^((25[0-5]|2[0-4][0-9]|1\d{2}|[1-9]?\d)\.){3}(25[0-5]|2[0-4][0-9]|1\d{2}|[1-9]?\d)$/.test(ip);
    }
    function isValidIPv6(ip) {
        return /^(([0-9a-fA-F]{1,4}):){7}([0-9a-fA-F]{1,4})$/.test(ip);
    }
    function isValidSubdomain(sub, allowUnderscore = false) {
        if (!sub) return true; // ריק זה תקף אם אופציונלי
        if (sub === '' || sub === '*' || sub === '@') return true; // allow just * or just @
        const labels = sub.split('.');

        return labels.every(label => {
            if (!label || label.length > 63) return false;
            if (label.startsWith('-') || label.endsWith('-')) return false;

            const pattern = allowUnderscore
                ? /^[\p{L}\p{N}_-]+$/u   // מתיר גם _
                : /^[\p{L}\p{N}-]+$/u;   // לא מתיר _

            return pattern.test(label);
        });
    }


    function isValidFullDomain(domain, allowUnderscore = false) {
        if (!domain) return false;

        domain = domain.trim();
        domain = domain.replace(/\.$/, '');

        const labels = domain.split('.');

        // דרישה לשם דומיין מלא (לפחות 2 תוויות: סאב+TLD)
        if (labels.length < 2) return false;

        // אפשר גם לבדוק שאורך כולל < 255 תווים אם רוצים

        return labels.every(label => {
            if (!label || label.length > 63) return false;
            if (label.startsWith('-') || label.endsWith('-')) return false;

            const pattern = allowUnderscore
                ? /^[\p{L}\p{N}_-]+$/u
                : /^[\p{L}\p{N}-]+$/u;

            return pattern.test(label);
        });
    }

    function isValidURL(url) {
        try {
            const parsed = new URL(url);

            // בדיקה שהפרוטוקול חוקי (http/https בלבד לדוגמה)
            if (!['http:', 'https:'].includes(parsed.protocol)) {
                return false;
            }

            // ודא שה־hostname כולל לפחות דומיין אחד (ולא רק "http://")
            if (!parsed.hostname || parsed.hostname.length < 1) {
                return false;
            }

            return true;
        } catch (e) {
            return false;
        }
    }

    function sanitizeSearchValue(value) {
        if (!value) {
            return '';
        }

        return String(value)
            .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069\u200B-\u200D\uFEFF\u00AD]/g, '')
            .replace(/[\u0000-\u001F\u007F]/g, '')
            .replace(/\u00A0/g, ' ')
            .trim();
    }

    function cleanQueryParamInUrl(paramName, input) {
        if (!window.URL || !window.URLSearchParams) {
            return;
        }

        var currentUrl = new URL(window.location.href);
        var currentValue = currentUrl.searchParams.get(paramName);

        if (currentValue === null) {
            return;
        }

        var cleanValue = sanitizeSearchValue(currentValue);

        if (cleanValue !== currentValue) {
            if (cleanValue) {
                currentUrl.searchParams.set(paramName, cleanValue);
            } else {
                currentUrl.searchParams.delete(paramName);
            }

            window.history.replaceState({}, '', currentUrl.toString());
        }

        if (input) {
            input.value = cleanValue;
        }
    }

    function bindSearchSanitizer(form, options) {
        if (!form) {
            return;
        }

        options = options || {};

        var queryParamName = options.queryParamName || 'q';
        var inputSelector = options.inputSelector || 'input[name="' + queryParamName + '"]';
        var input = form.querySelector(inputSelector);

        cleanQueryParamInUrl(queryParamName, input);

        if (!input) {
            return;
        }

        form.addEventListener('submit', function () {
            input.value = sanitizeSearchValue(input.value);
        });
    }

    // Reusable API for other pages/forms.
    window.SearchSanitizer = window.SearchSanitizer || {};
    window.SearchSanitizer.sanitize = sanitizeSearchValue;
    window.SearchSanitizer.bindForm = bindSearchSanitizer;
    window.SearchSanitizer.cleanUrlParam = cleanQueryParamInUrl;

    (function initSearchSanitizers() {
        // Current admin customers search form.
        bindSearchSanitizer(document.getElementById('filter_table_s'));
        bindSearchSanitizer(document.getElementById('filter_table_s'), {
            queryParamName: 'u',
            inputSelector: 'input[name="u"]'
        });

        // Future forms can opt-in by adding class + data attributes.
        $('.js-search-sanitize-form').each(function () {
            var form = this;
            bindSearchSanitizer(form, {
                queryParamName: form.getAttribute('data-query-param') || 'q',
                inputSelector: form.getAttribute('data-query-input') || undefined
            });
        });
    })();

    // Cookie name is promo_popup_dismissed_<id>
    (function promoPopupInit() {
        var wrap = document.getElementById('promo-popup-wrap');
        if (!wrap) return;
        var cookieName = wrap.getAttribute('data-cookie-name');
        var cookieDays = parseInt(wrap.getAttribute('data-cookie-days'), 10) || 7;

        function getCookie(name) {
            var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
            return m ? decodeURIComponent(m[1]) : null;
        }
        function setCookie(name, value, days) {
            var d = new Date();
            d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;expires=' + d.toUTCString() + ';SameSite=Lax';
        }

        if (getCookie(cookieName)) {
            if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
            return;
        }

        wrap.style.display = '';
        document.body.classList.add('promo-popup-open');

        var closeBtn = wrap.querySelector('.promo-popup-close');
        var overlay = wrap.querySelector('.promo-popup-overlay');

        function closePopup() {
            setCookie(cookieName, '1', cookieDays);
            wrap.style.display = 'none';
            document.body.classList.remove('promo-popup-open');
        }

        if (closeBtn) closeBtn.addEventListener('click', closePopup);
        if (overlay) overlay.addEventListener('click', closePopup);
    })();

});
